// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptInviteAsUser, activateRepositoryWritesForAWorkspaceIfAbsentAsUser, activateRepositoryWritesOrganizationWideAfterReviewAsUser, archiveAChannelEnvironmentAsUser, assignKeystoreEntryAsAdmin, attachAChannelEnvironmentAsUser, attachARepositoryToAChannelEnvironmentAsUser, attestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdmin, cancelTasksAsUser, cancelTeamsOutboxMessageAsAdmin, changeAChannelEnvironmentRepositoryBranchAsUser, createANewRepositoryChatConversationAsUser, createARepositoryChatMessageAsUser, createBillingPortalSessionAsUser, createChannelAsUser, createIndexingRunAsUser, createIssueIntegrationProjectAsUser, createKeystoreEntryAsAdmin, createMcpAccessTokenAsUser, createOrganizationAsUser, createSourceControlCredentialAsUser, createSourceControlProviderAsUser, createTopupSessionAsUser, decideADependencyRestoreRequestAsUser, declineInviteAsUser, deleteAChannelEnvironmentAsUser, deleteKeystoreEntryAsAdmin, deleteRepositoryAsUser, deleteSourceControlCredentialAsUser, deleteSourceControlWebhookAsUser, detachARepositoryFromAChannelEnvironmentAsUser, discoverRemoteBranchesAsUser, discoverRemoteIssueProjectsAsUser, discoverRemoteRepositoriesAsUser, downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublic, downloadCompileRecordingArtifactAsUser, downloadTelemetryPromptAsUser, downloadTelemetrySchemaAsUser, enableOrDisablePushForARepositoryAttachmentAsUser, enrollASandboxHostBindingAsAdmin, exchangeMcpOauthTokenAs, exportSchemaTelemetryAsUser, generateJiraLinkCodeAsUser, getAdminOverviewAsAdmin, getARepositoryChatConversationAsUser, getAuthorize, getAuthSessionAsPublic, getBillingBalanceAsUser, getDashboardOverviewAsUser, getFailedRepositoriesForIndexingRunAsUser, getFlowDetailsAsUser, getFlowStageJournalEntryAsUser, getIndexingRunInsightsAsUser, getInviteByTokenAsUser, getIssueDetailsAsUser, getIssueIntegrationProviderDetailAsUser, getKeystoreSpendingAsAdmin, getMcpOauthAuthorizationServerMetadataAs, getMcpProtectedResourceMetadataAs, getMcpProtectedResourceMetadataForArtiSkillMeshAs, getOrganizationAsUser, getPlanRevisionGraphAsUser, getPlanRevisionTelemetryAsUser, getPlanSnapshotByIdAsUser, getPlanSnapshotByIssueKeyAsUser, getPlanSnapshotByStoryIssueKeyAsUser, getPublicPlatformStatsAsPublic, getPushBrokerOverviewAsUser, getQuotaForecastingSummaryAsUser, getRepositoryTopologyAsUser, getSchemaTelemetryScopeSummaryAsUser, getSourceControlProviderDetailAsUser, getTaskDetailsAsUser, getTaskEventsAsUser, getTaskFacetsAsUser, getTaskLogsAsUser, getTeamsAdminSetupAsAdmin, getTeamsIntegrationStatusAsUser, getTelemetryRowByIdAsUser, getTimingSummaryAsUser, getUsageSummaryAsUser, getUserInstances, getUserInstancesByIdChannelsByChannelIdArtifacts, getUserInstancesByIdChannelsByChannelIdMessages, getUserInstancesByIdCost, getUserInstancesByIdMemory, getUserInstancesByIdObservabilityDiff, getUserInstancesByIdObservabilityList, getUserInstancesGrowthDistribution, githubAppInstallCallbackAsPublic, grantOrganizationCreditsAsAdmin, handleInternalEventAsInternal, handleStripeWebhookAsWebhook, ingestMetricEntriesFromRemoteServicesAsInternal, inspectASandboxHostBindingAndItsFenceTargetsAsAdmin, invalidateAllSessionsForAuserAsAdmin, invalidateOrganizationInviteAsUser, inviteOrganizationMemberAsUser, issueIntegrationOauthCallbackAsUser, joinWaitlistAsPublic, launchOrResumeAChannelWorkspaceFromAnIssueAsUser, listAgentModeBudgetsAsUser, listArchivedTeamsChannelsAsAdmin, listBillingTransactionsAsUser, listChannelEnvironmentRepositoryAttachmentsAsUser, listChannelsAsUser, listConnectedMcpOauthGrantsAsUser, listDefaultAgentModeBudgetsAsAdmin, listDependencyRestoreRequestsAsUser, listEnrolledSandboxHostBindingsAsAdmin, listFlowLockDiagnosticsAsUser, listFlowStageJournalAsUser, listIndexingRunsAsUser, listIssueIntegrationProvidersAsUser, listKeystoreEntriesAsAdmin, listMcpAccessTokensAsUser, listOrganizationApiKeysAsUser, listOrganizationFeatureFlagOverridesAsAdmin, listOrganizationInvitesAsUser, listOrganizationMcpServersAsUser, listOrganizationMembersAsUser, listOrganizationsAsUser, listOrganizationsForAdminAsAdmin, listOrSearchIssuesUsingStructuredFiltersAsUser, listPendingInvitesAsUser, listPlatformUsersAsAdmin, listPushPoliciesForAChannelEnvironmentAsUser, listQuotaForecastingEntriesAsUser, listRecentPlanSnapshotsAsUser, listRepositoryChatConversationsAsUser, listRetainedArtifactsForAChannelAsUser, listRetainedChannelArtifactVersionsAsUser, listSchemaTelemetryAsUser, listSelectableChannelEnvironmentProfilesAsUser, listSourceControlProvidersAsUser, listSourceControlRepositorySummariesAsUser, listTasksAsUser, listTeamsOutboxMessagesAsAdmin, listTimingEntriesAsUser, listUsageEntriesAsUser, logoutAsPublic, mintAndLaunchAChannelEnvironmentPreviewPortAsUser, mintTeamsChannelBindingTokenAsUser, type Options, patchAChannelEnvironmentAsUser, permanentlyDeleteAnIssueWorkspaceAggregateAsUser, postAuthorize, prepareCheckpointRecoveryFromAReplacedHostAsUser, previewCheckpointRecoveryFromAReplacedHostAsUser, readAChannelEnvironmentAsUser, readARetainedChannelArtifactAsUser, readARetainedChannelArtifactSectionAsUser, readRetainedChannelHistoryAsUser, reAuthorizeRevokedRepositoryWritesAsUser, refreshARepositoryAttachmentToItsRemoteBranchHeadAsUser, registerAnMcpOauthClientAs, registerAnMcpServerForTheOrganizationAsUser, releaseFlowLockAsUser, removeAnOrganizationMcpServerAsUser, removeMemberAsUser, requestOtpCodeAsPublic, reseedAgentModeBudgetsForOrganizationsAsAdmin, resolveActorAttributionsAsUser, restartAChannelEnvironmentAsUser, retryAFailedExecutionFlowAsUser, retryStartingAChannelEnvironment_sSandboxAsUser, retryTeamsOutboxMessageAsAdmin, reviewRepositoryWritesBeforeAnOrgWideActivationAsUser, revokeMcpAccessTokenAsUser, revokeMcpOauthGrantAsUser, revokeRepositoryWritesOrganizationWideAsUser, saveTeamsAdminSetupAsAdmin, selectOrganizationAsUser, setOrganizationFeatureFlagOverrideAsAdmin, setupGithubAppInstallationAsUser, setupGithubOrgWebhookAsUser, setUpOrganizationBillingAsUser, skipTeamsOutboxMessageAsAdmin, startACompileRecordingForACompletedExecutionFlowAsUser, unassignKeystoreEntryAsAdmin, updateAnOrganizationMcpServerAsUser, updateMemberRoleAsUser, updateSourceControlCredentialAsUser, upsertAgentModeBudgetsAsUser, upsertSourceControlRepositoriesAsUser, validateTeamsBotCredentialsAsAdmin, verifyOtpCodeAsPublic, verifySourceControlCredentialAsUser } from '../sdk.gen';
import type { AcceptInviteAsUserData, AcceptInviteAsUserResponse, ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData, ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserResponse, ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData, ActivateRepositoryWritesOrganizationWideAfterReviewAsUserResponse, ArchiveAChannelEnvironmentAsUserData, ArchiveAChannelEnvironmentAsUserResponse, AssignKeystoreEntryAsAdminData, AssignKeystoreEntryAsAdminResponse, AttachAChannelEnvironmentAsUserData, AttachAChannelEnvironmentAsUserResponse, AttachARepositoryToAChannelEnvironmentAsUserData, AttachARepositoryToAChannelEnvironmentAsUserResponse, AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData, AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminResponse, CancelTasksAsUserData, CancelTasksAsUserResponse, CancelTeamsOutboxMessageAsAdminData, CancelTeamsOutboxMessageAsAdminResponse, ChangeAChannelEnvironmentRepositoryBranchAsUserData, ChangeAChannelEnvironmentRepositoryBranchAsUserResponse, CreateANewRepositoryChatConversationAsUserData, CreateANewRepositoryChatConversationAsUserResponse, CreateARepositoryChatMessageAsUserData, CreateARepositoryChatMessageAsUserResponse, CreateBillingPortalSessionAsUserData, CreateBillingPortalSessionAsUserResponse, CreateChannelAsUserData, CreateChannelAsUserResponse, CreateIndexingRunAsUserData, CreateIndexingRunAsUserResponse, CreateIssueIntegrationProjectAsUserData, CreateIssueIntegrationProjectAsUserResponse, CreateKeystoreEntryAsAdminData, CreateKeystoreEntryAsAdminResponse, CreateMcpAccessTokenAsUserData, CreateMcpAccessTokenAsUserResponse, CreateOrganizationAsUserData, CreateOrganizationAsUserResponse, CreateSourceControlCredentialAsUserData, CreateSourceControlCredentialAsUserResponse, CreateSourceControlProviderAsUserData, CreateSourceControlProviderAsUserResponse, CreateTopupSessionAsUserData, CreateTopupSessionAsUserResponse, DecideADependencyRestoreRequestAsUserData, DecideADependencyRestoreRequestAsUserResponse, DeclineInviteAsUserData, DeclineInviteAsUserResponse, DeleteAChannelEnvironmentAsUserData, DeleteAChannelEnvironmentAsUserResponse, DeleteKeystoreEntryAsAdminData, DeleteKeystoreEntryAsAdminResponse, DeleteRepositoryAsUserData, DeleteRepositoryAsUserResponse, DeleteSourceControlCredentialAsUserData, DeleteSourceControlCredentialAsUserResponse, DeleteSourceControlWebhookAsUserData, DeleteSourceControlWebhookAsUserResponse, DetachARepositoryFromAChannelEnvironmentAsUserData, DetachARepositoryFromAChannelEnvironmentAsUserResponse, DiscoverRemoteBranchesAsUserData, DiscoverRemoteBranchesAsUserResponse, DiscoverRemoteIssueProjectsAsUserData, DiscoverRemoteIssueProjectsAsUserResponse, DiscoverRemoteRepositoriesAsUserData, DiscoverRemoteRepositoriesAsUserResponse, DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicData, DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicResponse, DownloadCompileRecordingArtifactAsUserData, DownloadCompileRecordingArtifactAsUserResponse, DownloadTelemetryPromptAsUserData, DownloadTelemetryPromptAsUserResponse, DownloadTelemetrySchemaAsUserData, DownloadTelemetrySchemaAsUserResponse, EnableOrDisablePushForARepositoryAttachmentAsUserData, EnableOrDisablePushForARepositoryAttachmentAsUserResponse, EnrollASandboxHostBindingAsAdminData, EnrollASandboxHostBindingAsAdminResponse, ExchangeMcpOauthTokenAsData, ExchangeMcpOauthTokenAsResponse, ExportSchemaTelemetryAsUserData, ExportSchemaTelemetryAsUserResponse, GenerateJiraLinkCodeAsUserData, GenerateJiraLinkCodeAsUserResponse, GetAdminOverviewAsAdminData, GetAdminOverviewAsAdminResponse, GetARepositoryChatConversationAsUserData, GetARepositoryChatConversationAsUserResponse, GetAuthorizeData, GetAuthSessionAsPublicData, GetAuthSessionAsPublicResponse, GetBillingBalanceAsUserData, GetBillingBalanceAsUserResponse, GetDashboardOverviewAsUserData, GetDashboardOverviewAsUserResponse, GetFailedRepositoriesForIndexingRunAsUserData, GetFailedRepositoriesForIndexingRunAsUserResponse, GetFlowDetailsAsUserData, GetFlowDetailsAsUserResponse, GetFlowStageJournalEntryAsUserData, GetFlowStageJournalEntryAsUserResponse, GetIndexingRunInsightsAsUserData, GetIndexingRunInsightsAsUserResponse, GetInviteByTokenAsUserData, GetInviteByTokenAsUserResponse, GetIssueDetailsAsUserData, GetIssueDetailsAsUserResponse, GetIssueIntegrationProviderDetailAsUserData, GetIssueIntegrationProviderDetailAsUserResponse, GetKeystoreSpendingAsAdminData, GetKeystoreSpendingAsAdminResponse, GetMcpOauthAuthorizationServerMetadataAsData, GetMcpOauthAuthorizationServerMetadataAsResponse, GetMcpProtectedResourceMetadataAsData, GetMcpProtectedResourceMetadataAsResponse, GetMcpProtectedResourceMetadataForArtiSkillMeshAsData, GetMcpProtectedResourceMetadataForArtiSkillMeshAsResponse, GetOrganizationAsUserData, GetOrganizationAsUserResponse, GetPlanRevisionGraphAsUserData, GetPlanRevisionGraphAsUserResponse, GetPlanRevisionTelemetryAsUserData, GetPlanRevisionTelemetryAsUserResponse, GetPlanSnapshotByIdAsUserData, GetPlanSnapshotByIdAsUserResponse, GetPlanSnapshotByIssueKeyAsUserData, GetPlanSnapshotByIssueKeyAsUserResponse, GetPlanSnapshotByStoryIssueKeyAsUserData, GetPlanSnapshotByStoryIssueKeyAsUserResponse, GetPublicPlatformStatsAsPublicData, GetPublicPlatformStatsAsPublicResponse, GetPushBrokerOverviewAsUserData, GetPushBrokerOverviewAsUserResponse, GetQuotaForecastingSummaryAsUserData, GetQuotaForecastingSummaryAsUserResponse, GetRepositoryTopologyAsUserData, GetRepositoryTopologyAsUserResponse, GetSchemaTelemetryScopeSummaryAsUserData, GetSchemaTelemetryScopeSummaryAsUserResponse, GetSourceControlProviderDetailAsUserData, GetSourceControlProviderDetailAsUserResponse, GetTaskDetailsAsUserData, GetTaskDetailsAsUserResponse, GetTaskEventsAsUserData, GetTaskEventsAsUserResponse, GetTaskFacetsAsUserData, GetTaskFacetsAsUserResponse, GetTaskLogsAsUserData, GetTaskLogsAsUserResponse, GetTeamsAdminSetupAsAdminData, GetTeamsAdminSetupAsAdminResponse, GetTeamsIntegrationStatusAsUserData, GetTeamsIntegrationStatusAsUserResponse, GetTelemetryRowByIdAsUserData, GetTelemetryRowByIdAsUserResponse, GetTimingSummaryAsUserData, GetTimingSummaryAsUserResponse, GetUsageSummaryAsUserData, GetUsageSummaryAsUserResponse, GetUserInstancesByIdChannelsByChannelIdArtifactsData, GetUserInstancesByIdChannelsByChannelIdMessagesData, GetUserInstancesByIdCostData, GetUserInstancesByIdMemoryData, GetUserInstancesByIdObservabilityDiffData, GetUserInstancesByIdObservabilityListData, GetUserInstancesData, GetUserInstancesGrowthDistributionData, GithubAppInstallCallbackAsPublicData, GithubAppInstallCallbackAsPublicResponse, GrantOrganizationCreditsAsAdminData, GrantOrganizationCreditsAsAdminResponse, HandleInternalEventAsInternalData, HandleInternalEventAsInternalResponse, HandleStripeWebhookAsWebhookData, HandleStripeWebhookAsWebhookResponse, IngestMetricEntriesFromRemoteServicesAsInternalData, IngestMetricEntriesFromRemoteServicesAsInternalResponse, InspectASandboxHostBindingAndItsFenceTargetsAsAdminData, InspectASandboxHostBindingAndItsFenceTargetsAsAdminResponse, InvalidateAllSessionsForAuserAsAdminData, InvalidateAllSessionsForAuserAsAdminResponse, InvalidateOrganizationInviteAsUserData, InvalidateOrganizationInviteAsUserResponse, InviteOrganizationMemberAsUserData, InviteOrganizationMemberAsUserResponse, IssueIntegrationOauthCallbackAsUserData, IssueIntegrationOauthCallbackAsUserResponse, JoinWaitlistAsPublicData, JoinWaitlistAsPublicResponse, LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData, LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserResponse, ListAgentModeBudgetsAsUserData, ListAgentModeBudgetsAsUserResponse, ListArchivedTeamsChannelsAsAdminData, ListArchivedTeamsChannelsAsAdminResponse, ListBillingTransactionsAsUserData, ListBillingTransactionsAsUserResponse, ListChannelEnvironmentRepositoryAttachmentsAsUserData, ListChannelEnvironmentRepositoryAttachmentsAsUserResponse, ListChannelsAsUserData, ListChannelsAsUserResponse, ListConnectedMcpOauthGrantsAsUserData, ListConnectedMcpOauthGrantsAsUserResponse, ListDefaultAgentModeBudgetsAsAdminData, ListDefaultAgentModeBudgetsAsAdminResponse, ListDependencyRestoreRequestsAsUserData, ListDependencyRestoreRequestsAsUserResponse, ListEnrolledSandboxHostBindingsAsAdminData, ListEnrolledSandboxHostBindingsAsAdminResponse, ListFlowLockDiagnosticsAsUserData, ListFlowLockDiagnosticsAsUserResponse, ListFlowStageJournalAsUserData, ListFlowStageJournalAsUserResponse, ListIndexingRunsAsUserData, ListIndexingRunsAsUserResponse, ListIssueIntegrationProvidersAsUserData, ListIssueIntegrationProvidersAsUserResponse, ListKeystoreEntriesAsAdminData, ListKeystoreEntriesAsAdminResponse, ListMcpAccessTokensAsUserData, ListMcpAccessTokensAsUserResponse, ListOrganizationApiKeysAsUserData, ListOrganizationApiKeysAsUserResponse, ListOrganizationFeatureFlagOverridesAsAdminData, ListOrganizationFeatureFlagOverridesAsAdminResponse, ListOrganizationInvitesAsUserData, ListOrganizationInvitesAsUserResponse, ListOrganizationMcpServersAsUserData, ListOrganizationMcpServersAsUserResponse, ListOrganizationMembersAsUserData, ListOrganizationMembersAsUserResponse, ListOrganizationsAsUserData, ListOrganizationsAsUserResponse, ListOrganizationsForAdminAsAdminData, ListOrganizationsForAdminAsAdminResponse, ListOrSearchIssuesUsingStructuredFiltersAsUserData, ListOrSearchIssuesUsingStructuredFiltersAsUserResponse, ListPendingInvitesAsUserData, ListPendingInvitesAsUserResponse, ListPlatformUsersAsAdminData, ListPlatformUsersAsAdminResponse, ListPushPoliciesForAChannelEnvironmentAsUserData, ListPushPoliciesForAChannelEnvironmentAsUserResponse, ListQuotaForecastingEntriesAsUserData, ListQuotaForecastingEntriesAsUserResponse, ListRecentPlanSnapshotsAsUserData, ListRecentPlanSnapshotsAsUserResponse, ListRepositoryChatConversationsAsUserData, ListRepositoryChatConversationsAsUserResponse, ListRetainedArtifactsForAChannelAsUserData, ListRetainedArtifactsForAChannelAsUserResponse, ListRetainedChannelArtifactVersionsAsUserData, ListRetainedChannelArtifactVersionsAsUserResponse, ListSchemaTelemetryAsUserData, ListSchemaTelemetryAsUserResponse, ListSelectableChannelEnvironmentProfilesAsUserData, ListSelectableChannelEnvironmentProfilesAsUserResponse, ListSourceControlProvidersAsUserData, ListSourceControlProvidersAsUserResponse, ListSourceControlRepositorySummariesAsUserData, ListSourceControlRepositorySummariesAsUserResponse, ListTasksAsUserData, ListTasksAsUserResponse, ListTeamsOutboxMessagesAsAdminData, ListTeamsOutboxMessagesAsAdminResponse, ListTimingEntriesAsUserData, ListTimingEntriesAsUserResponse, ListUsageEntriesAsUserData, ListUsageEntriesAsUserResponse, LogoutAsPublicData, LogoutAsPublicResponse, MintAndLaunchAChannelEnvironmentPreviewPortAsUserData, MintAndLaunchAChannelEnvironmentPreviewPortAsUserResponse, MintTeamsChannelBindingTokenAsUserData, MintTeamsChannelBindingTokenAsUserResponse, PatchAChannelEnvironmentAsUserData, PatchAChannelEnvironmentAsUserResponse, PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData, PermanentlyDeleteAnIssueWorkspaceAggregateAsUserResponse, PostAuthorizeData, PrepareCheckpointRecoveryFromAReplacedHostAsUserData, PrepareCheckpointRecoveryFromAReplacedHostAsUserResponse, PreviewCheckpointRecoveryFromAReplacedHostAsUserData, PreviewCheckpointRecoveryFromAReplacedHostAsUserResponse, ReadAChannelEnvironmentAsUserData, ReadAChannelEnvironmentAsUserResponse, ReadARetainedChannelArtifactAsUserData, ReadARetainedChannelArtifactAsUserResponse, ReadARetainedChannelArtifactSectionAsUserData, ReadARetainedChannelArtifactSectionAsUserResponse, ReadRetainedChannelHistoryAsUserData, ReadRetainedChannelHistoryAsUserResponse, ReAuthorizeRevokedRepositoryWritesAsUserData, ReAuthorizeRevokedRepositoryWritesAsUserResponse, RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData, RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserResponse, RegisterAnMcpOauthClientAsData, RegisterAnMcpOauthClientAsResponse, RegisterAnMcpServerForTheOrganizationAsUserData, RegisterAnMcpServerForTheOrganizationAsUserResponse, ReleaseFlowLockAsUserData, ReleaseFlowLockAsUserResponse, RemoveAnOrganizationMcpServerAsUserData, RemoveAnOrganizationMcpServerAsUserResponse, RemoveMemberAsUserData, RemoveMemberAsUserResponse, RequestOtpCodeAsPublicData, RequestOtpCodeAsPublicResponse, ReseedAgentModeBudgetsForOrganizationsAsAdminData, ReseedAgentModeBudgetsForOrganizationsAsAdminResponse, ResolveActorAttributionsAsUserData, ResolveActorAttributionsAsUserResponse, RestartAChannelEnvironmentAsUserData, RestartAChannelEnvironmentAsUserResponse, RetryAFailedExecutionFlowAsUserData, RetryAFailedExecutionFlowAsUserResponse, RetryStartingAChannelEnvironmentSSandboxAsUserData, RetryStartingAChannelEnvironmentSSandboxAsUserResponse, RetryTeamsOutboxMessageAsAdminData, RetryTeamsOutboxMessageAsAdminResponse, ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserData, ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserResponse, RevokeMcpAccessTokenAsUserData, RevokeMcpAccessTokenAsUserResponse, RevokeMcpOauthGrantAsUserData, RevokeMcpOauthGrantAsUserResponse, RevokeRepositoryWritesOrganizationWideAsUserData, RevokeRepositoryWritesOrganizationWideAsUserResponse, SaveTeamsAdminSetupAsAdminData, SaveTeamsAdminSetupAsAdminResponse, SelectOrganizationAsUserData, SelectOrganizationAsUserResponse, SetOrganizationFeatureFlagOverrideAsAdminData, SetOrganizationFeatureFlagOverrideAsAdminResponse, SetupGithubAppInstallationAsUserData, SetupGithubAppInstallationAsUserResponse, SetupGithubOrgWebhookAsUserData, SetupGithubOrgWebhookAsUserResponse, SetUpOrganizationBillingAsUserData, SetUpOrganizationBillingAsUserResponse, SkipTeamsOutboxMessageAsAdminData, SkipTeamsOutboxMessageAsAdminResponse, StartACompileRecordingForACompletedExecutionFlowAsUserData, StartACompileRecordingForACompletedExecutionFlowAsUserResponse, UnassignKeystoreEntryAsAdminData, UnassignKeystoreEntryAsAdminResponse, UpdateAnOrganizationMcpServerAsUserData, UpdateAnOrganizationMcpServerAsUserResponse, UpdateMemberRoleAsUserData, UpdateMemberRoleAsUserResponse, UpdateSourceControlCredentialAsUserData, UpdateSourceControlCredentialAsUserResponse, UpsertAgentModeBudgetsAsUserData, UpsertAgentModeBudgetsAsUserResponse, UpsertSourceControlRepositoriesAsUserData, UpsertSourceControlRepositoriesAsUserResponse, ValidateTeamsBotCredentialsAsAdminData, ValidateTeamsBotCredentialsAsAdminResponse, VerifyOtpCodeAsPublicData, VerifyOtpCodeAsPublicResponse, VerifySourceControlCredentialAsUserData, VerifySourceControlCredentialAsUserResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getMcpOauthAuthorizationServerMetadataAsQueryKey = (options?: Options<GetMcpOauthAuthorizationServerMetadataAsData>) => createQueryKey('getMcpOauthAuthorizationServerMetadataAs', options);

/**
 * Get MCP OAuth authorization server metadata
 */
export const getMcpOauthAuthorizationServerMetadataAsOptions = (options?: Options<GetMcpOauthAuthorizationServerMetadataAsData>) => queryOptions<GetMcpOauthAuthorizationServerMetadataAsResponse, DefaultError, GetMcpOauthAuthorizationServerMetadataAsResponse, ReturnType<typeof getMcpOauthAuthorizationServerMetadataAsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMcpOauthAuthorizationServerMetadataAs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMcpOauthAuthorizationServerMetadataAsQueryKey(options)
});

export const getMcpProtectedResourceMetadataAsQueryKey = (options?: Options<GetMcpProtectedResourceMetadataAsData>) => createQueryKey('getMcpProtectedResourceMetadataAs', options);

/**
 * Get MCP protected resource metadata
 */
export const getMcpProtectedResourceMetadataAsOptions = (options?: Options<GetMcpProtectedResourceMetadataAsData>) => queryOptions<GetMcpProtectedResourceMetadataAsResponse, DefaultError, GetMcpProtectedResourceMetadataAsResponse, ReturnType<typeof getMcpProtectedResourceMetadataAsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMcpProtectedResourceMetadataAs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMcpProtectedResourceMetadataAsQueryKey(options)
});

export const getMcpProtectedResourceMetadataForArtiSkillMeshAsQueryKey = (options?: Options<GetMcpProtectedResourceMetadataForArtiSkillMeshAsData>) => createQueryKey('getMcpProtectedResourceMetadataForArtiSkillMeshAs', options);

/**
 * Get MCP protected resource metadata for Arti Skill Mesh
 */
export const getMcpProtectedResourceMetadataForArtiSkillMeshAsOptions = (options?: Options<GetMcpProtectedResourceMetadataForArtiSkillMeshAsData>) => queryOptions<GetMcpProtectedResourceMetadataForArtiSkillMeshAsResponse, DefaultError, GetMcpProtectedResourceMetadataForArtiSkillMeshAsResponse, ReturnType<typeof getMcpProtectedResourceMetadataForArtiSkillMeshAsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMcpProtectedResourceMetadataForArtiSkillMeshAs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMcpProtectedResourceMetadataForArtiSkillMeshAsQueryKey(options)
});

export const getAuthorizeQueryKey = (options: Options<GetAuthorizeData>) => createQueryKey('getAuthorize', options);

export const getAuthorizeOptions = (options: Options<GetAuthorizeData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getAuthorizeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthorize({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthorizeQueryKey(options)
});

export const postAuthorizeMutation = (options?: Partial<Options<PostAuthorizeData>>): UseMutationOptions<unknown, DefaultError, Options<PostAuthorizeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostAuthorizeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAuthorize({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register an MCP OAuth client
 */
export const registerAnMcpOauthClientAsMutation = (options?: Partial<Options<RegisterAnMcpOauthClientAsData>>): UseMutationOptions<RegisterAnMcpOauthClientAsResponse, DefaultError, Options<RegisterAnMcpOauthClientAsData>> => {
    const mutationOptions: UseMutationOptions<RegisterAnMcpOauthClientAsResponse, DefaultError, Options<RegisterAnMcpOauthClientAsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerAnMcpOauthClientAs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange MCP OAuth token
 */
export const exchangeMcpOauthTokenAsMutation = (options?: Partial<Options<ExchangeMcpOauthTokenAsData>>): UseMutationOptions<ExchangeMcpOauthTokenAsResponse, DefaultError, Options<ExchangeMcpOauthTokenAsData>> => {
    const mutationOptions: UseMutationOptions<ExchangeMcpOauthTokenAsResponse, DefaultError, Options<ExchangeMcpOauthTokenAsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exchangeMcpOauthTokenAs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAuthSessionAsPublicQueryKey = (options?: Options<GetAuthSessionAsPublicData>) => createQueryKey('getAuthSessionAsPublic', options);

/**
 * Get auth session
 */
export const getAuthSessionAsPublicOptions = (options?: Options<GetAuthSessionAsPublicData>) => queryOptions<GetAuthSessionAsPublicResponse, DefaultError, GetAuthSessionAsPublicResponse, ReturnType<typeof getAuthSessionAsPublicQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthSessionAsPublic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthSessionAsPublicQueryKey(options)
});

/**
 *  Logout
 */
export const logoutAsPublicMutation = (options?: Partial<Options<LogoutAsPublicData>>): UseMutationOptions<LogoutAsPublicResponse, DefaultError, Options<LogoutAsPublicData>> => {
    const mutationOptions: UseMutationOptions<LogoutAsPublicResponse, DefaultError, Options<LogoutAsPublicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutAsPublic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request OTP code
 */
export const requestOtpCodeAsPublicMutation = (options?: Partial<Options<RequestOtpCodeAsPublicData>>): UseMutationOptions<RequestOtpCodeAsPublicResponse, DefaultError, Options<RequestOtpCodeAsPublicData>> => {
    const mutationOptions: UseMutationOptions<RequestOtpCodeAsPublicResponse, DefaultError, Options<RequestOtpCodeAsPublicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestOtpCodeAsPublic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify OTP code
 */
export const verifyOtpCodeAsPublicMutation = (options?: Partial<Options<VerifyOtpCodeAsPublicData>>): UseMutationOptions<VerifyOtpCodeAsPublicResponse, DefaultError, Options<VerifyOtpCodeAsPublicData>> => {
    const mutationOptions: UseMutationOptions<VerifyOtpCodeAsPublicResponse, DefaultError, Options<VerifyOtpCodeAsPublicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyOtpCodeAsPublic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicQueryKey = (options: Options<DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicData>) => createQueryKey('downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublic', options);

/**
 * Download an immutable skill file or export using a five-minute signed capability
 */
export const downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicOptions = (options: Options<DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicData>) => queryOptions<DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicResponse, DefaultError, DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicResponse, ReturnType<typeof downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicQueryKey(options)
});

export const githubAppInstallCallbackAsPublicQueryKey = (options?: Options<GithubAppInstallCallbackAsPublicData>) => createQueryKey('githubAppInstallCallbackAsPublic', options);

/**
 * GitHub App install callback
 */
export const githubAppInstallCallbackAsPublicOptions = (options?: Options<GithubAppInstallCallbackAsPublicData>) => queryOptions<GithubAppInstallCallbackAsPublicResponse, DefaultError, GithubAppInstallCallbackAsPublicResponse, ReturnType<typeof githubAppInstallCallbackAsPublicQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await githubAppInstallCallbackAsPublic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: githubAppInstallCallbackAsPublicQueryKey(options)
});

export const getPublicPlatformStatsAsPublicQueryKey = (options?: Options<GetPublicPlatformStatsAsPublicData>) => createQueryKey('getPublicPlatformStatsAsPublic', options);

/**
 * Get public platform stats
 */
export const getPublicPlatformStatsAsPublicOptions = (options?: Options<GetPublicPlatformStatsAsPublicData>) => queryOptions<GetPublicPlatformStatsAsPublicResponse, DefaultError, GetPublicPlatformStatsAsPublicResponse, ReturnType<typeof getPublicPlatformStatsAsPublicQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPublicPlatformStatsAsPublic({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPublicPlatformStatsAsPublicQueryKey(options)
});

/**
 * Join waitlist
 */
export const joinWaitlistAsPublicMutation = (options?: Partial<Options<JoinWaitlistAsPublicData>>): UseMutationOptions<JoinWaitlistAsPublicResponse, DefaultError, Options<JoinWaitlistAsPublicData>> => {
    const mutationOptions: UseMutationOptions<JoinWaitlistAsPublicResponse, DefaultError, Options<JoinWaitlistAsPublicData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinWaitlistAsPublic({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle internal event
 */
export const handleInternalEventAsInternalMutation = (options?: Partial<Options<HandleInternalEventAsInternalData>>): UseMutationOptions<HandleInternalEventAsInternalResponse, DefaultError, Options<HandleInternalEventAsInternalData>> => {
    const mutationOptions: UseMutationOptions<HandleInternalEventAsInternalResponse, DefaultError, Options<HandleInternalEventAsInternalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleInternalEventAsInternal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ingest metric entries from remote services
 */
export const ingestMetricEntriesFromRemoteServicesAsInternalMutation = (options?: Partial<Options<IngestMetricEntriesFromRemoteServicesAsInternalData>>): UseMutationOptions<IngestMetricEntriesFromRemoteServicesAsInternalResponse, DefaultError, Options<IngestMetricEntriesFromRemoteServicesAsInternalData>> => {
    const mutationOptions: UseMutationOptions<IngestMetricEntriesFromRemoteServicesAsInternalResponse, DefaultError, Options<IngestMetricEntriesFromRemoteServicesAsInternalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ingestMetricEntriesFromRemoteServicesAsInternal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDependencyRestoreRequestsAsUserQueryKey = (options: Options<ListDependencyRestoreRequestsAsUserData>) => createQueryKey('listDependencyRestoreRequestsAsUser', options);

/**
 * List dependency restore requests
 */
export const listDependencyRestoreRequestsAsUserOptions = (options: Options<ListDependencyRestoreRequestsAsUserData>) => queryOptions<ListDependencyRestoreRequestsAsUserResponse, DefaultError, ListDependencyRestoreRequestsAsUserResponse, ReturnType<typeof listDependencyRestoreRequestsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDependencyRestoreRequestsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDependencyRestoreRequestsAsUserQueryKey(options)
});

/**
 * Decide a dependency restore request
 */
export const decideADependencyRestoreRequestAsUserMutation = (options?: Partial<Options<DecideADependencyRestoreRequestAsUserData>>): UseMutationOptions<DecideADependencyRestoreRequestAsUserResponse, DefaultError, Options<DecideADependencyRestoreRequestAsUserData>> => {
    const mutationOptions: UseMutationOptions<DecideADependencyRestoreRequestAsUserResponse, DefaultError, Options<DecideADependencyRestoreRequestAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideADependencyRestoreRequestAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve actor attributions
 */
export const resolveActorAttributionsAsUserMutation = (options?: Partial<Options<ResolveActorAttributionsAsUserData>>): UseMutationOptions<ResolveActorAttributionsAsUserResponse, DefaultError, Options<ResolveActorAttributionsAsUserData>> => {
    const mutationOptions: UseMutationOptions<ResolveActorAttributionsAsUserResponse, DefaultError, Options<ResolveActorAttributionsAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resolveActorAttributionsAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRetainedArtifactsForAChannelAsUserQueryKey = (options: Options<ListRetainedArtifactsForAChannelAsUserData>) => createQueryKey('listRetainedArtifactsForAChannelAsUser', options);

/**
 * List retained artifacts for a channel
 */
export const listRetainedArtifactsForAChannelAsUserOptions = (options: Options<ListRetainedArtifactsForAChannelAsUserData>) => queryOptions<ListRetainedArtifactsForAChannelAsUserResponse, DefaultError, ListRetainedArtifactsForAChannelAsUserResponse, ReturnType<typeof listRetainedArtifactsForAChannelAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRetainedArtifactsForAChannelAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRetainedArtifactsForAChannelAsUserQueryKey(options)
});

export const readARetainedChannelArtifactAsUserQueryKey = (options: Options<ReadARetainedChannelArtifactAsUserData>) => createQueryKey('readARetainedChannelArtifactAsUser', options);

/**
 * Read a retained channel artifact
 */
export const readARetainedChannelArtifactAsUserOptions = (options: Options<ReadARetainedChannelArtifactAsUserData>) => queryOptions<ReadARetainedChannelArtifactAsUserResponse, DefaultError, ReadARetainedChannelArtifactAsUserResponse, ReturnType<typeof readARetainedChannelArtifactAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readARetainedChannelArtifactAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readARetainedChannelArtifactAsUserQueryKey(options)
});

export const readARetainedChannelArtifactSectionAsUserQueryKey = (options: Options<ReadARetainedChannelArtifactSectionAsUserData>) => createQueryKey('readARetainedChannelArtifactSectionAsUser', options);

/**
 * Read a retained channel artifact section
 */
export const readARetainedChannelArtifactSectionAsUserOptions = (options: Options<ReadARetainedChannelArtifactSectionAsUserData>) => queryOptions<ReadARetainedChannelArtifactSectionAsUserResponse, DefaultError, ReadARetainedChannelArtifactSectionAsUserResponse, ReturnType<typeof readARetainedChannelArtifactSectionAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readARetainedChannelArtifactSectionAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readARetainedChannelArtifactSectionAsUserQueryKey(options)
});

export const listRetainedChannelArtifactVersionsAsUserQueryKey = (options: Options<ListRetainedChannelArtifactVersionsAsUserData>) => createQueryKey('listRetainedChannelArtifactVersionsAsUser', options);

/**
 * List retained channel artifact versions
 */
export const listRetainedChannelArtifactVersionsAsUserOptions = (options: Options<ListRetainedChannelArtifactVersionsAsUserData>) => queryOptions<ListRetainedChannelArtifactVersionsAsUserResponse, DefaultError, ListRetainedChannelArtifactVersionsAsUserResponse, ReturnType<typeof listRetainedChannelArtifactVersionsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRetainedChannelArtifactVersionsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRetainedChannelArtifactVersionsAsUserQueryKey(options)
});

export const listChannelsAsUserQueryKey = (options?: Options<ListChannelsAsUserData>) => createQueryKey('listChannelsAsUser', options);

/**
 * List channels
 */
export const listChannelsAsUserOptions = (options?: Options<ListChannelsAsUserData>) => queryOptions<ListChannelsAsUserResponse, DefaultError, ListChannelsAsUserResponse, ReturnType<typeof listChannelsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChannelsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChannelsAsUserQueryKey(options)
});

/**
 * Create channel
 */
export const createChannelAsUserMutation = (options?: Partial<Options<CreateChannelAsUserData>>): UseMutationOptions<CreateChannelAsUserResponse, DefaultError, Options<CreateChannelAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateChannelAsUserResponse, DefaultError, Options<CreateChannelAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createChannelAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readRetainedChannelHistoryAsUserQueryKey = (options: Options<ReadRetainedChannelHistoryAsUserData>) => createQueryKey('readRetainedChannelHistoryAsUser', options);

/**
 * Read retained channel history
 */
export const readRetainedChannelHistoryAsUserOptions = (options: Options<ReadRetainedChannelHistoryAsUserData>) => queryOptions<ReadRetainedChannelHistoryAsUserResponse, DefaultError, ReadRetainedChannelHistoryAsUserResponse, ReturnType<typeof readRetainedChannelHistoryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readRetainedChannelHistoryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readRetainedChannelHistoryAsUserQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const readRetainedChannelHistoryAsUserInfiniteQueryKey = (options: Options<ReadRetainedChannelHistoryAsUserData>): QueryKey<Options<ReadRetainedChannelHistoryAsUserData>> => createQueryKey('readRetainedChannelHistoryAsUser', options, true);

/**
 * Read retained channel history
 */
export const readRetainedChannelHistoryAsUserInfiniteOptions = (options: Options<ReadRetainedChannelHistoryAsUserData>) => infiniteQueryOptions<ReadRetainedChannelHistoryAsUserResponse, DefaultError, InfiniteData<ReadRetainedChannelHistoryAsUserResponse>, QueryKey<Options<ReadRetainedChannelHistoryAsUserData>>, string | Pick<QueryKey<Options<ReadRetainedChannelHistoryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ReadRetainedChannelHistoryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await readRetainedChannelHistoryAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readRetainedChannelHistoryAsUserInfiniteQueryKey(options)
});

/**
 * Delete a channel environment
 */
export const deleteAChannelEnvironmentAsUserMutation = (options?: Partial<Options<DeleteAChannelEnvironmentAsUserData>>): UseMutationOptions<DeleteAChannelEnvironmentAsUserResponse, DefaultError, Options<DeleteAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteAChannelEnvironmentAsUserResponse, DefaultError, Options<DeleteAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readAChannelEnvironmentAsUserQueryKey = (options: Options<ReadAChannelEnvironmentAsUserData>) => createQueryKey('readAChannelEnvironmentAsUser', options);

/**
 * Read a channel environment
 */
export const readAChannelEnvironmentAsUserOptions = (options: Options<ReadAChannelEnvironmentAsUserData>) => queryOptions<ReadAChannelEnvironmentAsUserResponse, DefaultError, ReadAChannelEnvironmentAsUserResponse, ReturnType<typeof readAChannelEnvironmentAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readAChannelEnvironmentAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readAChannelEnvironmentAsUserQueryKey(options)
});

/**
 * Patch a channel environment
 */
export const patchAChannelEnvironmentAsUserMutation = (options?: Partial<Options<PatchAChannelEnvironmentAsUserData>>): UseMutationOptions<PatchAChannelEnvironmentAsUserResponse, DefaultError, Options<PatchAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<PatchAChannelEnvironmentAsUserResponse, DefaultError, Options<PatchAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Attach a channel environment
 */
export const attachAChannelEnvironmentAsUserMutation = (options?: Partial<Options<AttachAChannelEnvironmentAsUserData>>): UseMutationOptions<AttachAChannelEnvironmentAsUserResponse, DefaultError, Options<AttachAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<AttachAChannelEnvironmentAsUserResponse, DefaultError, Options<AttachAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChannelEnvironmentRepositoryAttachmentsAsUserQueryKey = (options: Options<ListChannelEnvironmentRepositoryAttachmentsAsUserData>) => createQueryKey('listChannelEnvironmentRepositoryAttachmentsAsUser', options);

/**
 * List channel environment repository attachments
 */
export const listChannelEnvironmentRepositoryAttachmentsAsUserOptions = (options: Options<ListChannelEnvironmentRepositoryAttachmentsAsUserData>) => queryOptions<ListChannelEnvironmentRepositoryAttachmentsAsUserResponse, DefaultError, ListChannelEnvironmentRepositoryAttachmentsAsUserResponse, ReturnType<typeof listChannelEnvironmentRepositoryAttachmentsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChannelEnvironmentRepositoryAttachmentsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChannelEnvironmentRepositoryAttachmentsAsUserQueryKey(options)
});

/**
 * Attach a repository to a channel environment
 */
export const attachARepositoryToAChannelEnvironmentAsUserMutation = (options?: Partial<Options<AttachARepositoryToAChannelEnvironmentAsUserData>>): UseMutationOptions<AttachARepositoryToAChannelEnvironmentAsUserResponse, DefaultError, Options<AttachARepositoryToAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<AttachARepositoryToAChannelEnvironmentAsUserResponse, DefaultError, Options<AttachARepositoryToAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachARepositoryToAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mint and launch a channel environment preview port
 */
export const mintAndLaunchAChannelEnvironmentPreviewPortAsUserMutation = (options?: Partial<Options<MintAndLaunchAChannelEnvironmentPreviewPortAsUserData>>): UseMutationOptions<MintAndLaunchAChannelEnvironmentPreviewPortAsUserResponse, DefaultError, Options<MintAndLaunchAChannelEnvironmentPreviewPortAsUserData>> => {
    const mutationOptions: UseMutationOptions<MintAndLaunchAChannelEnvironmentPreviewPortAsUserResponse, DefaultError, Options<MintAndLaunchAChannelEnvironmentPreviewPortAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mintAndLaunchAChannelEnvironmentPreviewPortAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Detach a repository from a channel environment
 */
export const detachARepositoryFromAChannelEnvironmentAsUserMutation = (options?: Partial<Options<DetachARepositoryFromAChannelEnvironmentAsUserData>>): UseMutationOptions<DetachARepositoryFromAChannelEnvironmentAsUserResponse, DefaultError, Options<DetachARepositoryFromAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<DetachARepositoryFromAChannelEnvironmentAsUserResponse, DefaultError, Options<DetachARepositoryFromAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await detachARepositoryFromAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change a channel environment repository branch
 */
export const changeAChannelEnvironmentRepositoryBranchAsUserMutation = (options?: Partial<Options<ChangeAChannelEnvironmentRepositoryBranchAsUserData>>): UseMutationOptions<ChangeAChannelEnvironmentRepositoryBranchAsUserResponse, DefaultError, Options<ChangeAChannelEnvironmentRepositoryBranchAsUserData>> => {
    const mutationOptions: UseMutationOptions<ChangeAChannelEnvironmentRepositoryBranchAsUserResponse, DefaultError, Options<ChangeAChannelEnvironmentRepositoryBranchAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeAChannelEnvironmentRepositoryBranchAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh a repository attachment to its remote branch head
 */
export const refreshARepositoryAttachmentToItsRemoteBranchHeadAsUserMutation = (options?: Partial<Options<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData>>): UseMutationOptions<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserResponse, DefaultError, Options<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData>> => {
    const mutationOptions: UseMutationOptions<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserResponse, DefaultError, Options<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshARepositoryAttachmentToItsRemoteBranchHeadAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Restart a channel environment
 */
export const restartAChannelEnvironmentAsUserMutation = (options?: Partial<Options<RestartAChannelEnvironmentAsUserData>>): UseMutationOptions<RestartAChannelEnvironmentAsUserResponse, DefaultError, Options<RestartAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<RestartAChannelEnvironmentAsUserResponse, DefaultError, Options<RestartAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restartAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry starting a channel environment's sandbox
 */
export const retryStartingAChannelEnvironmentSSandboxAsUserMutation = (options?: Partial<Options<RetryStartingAChannelEnvironmentSSandboxAsUserData>>): UseMutationOptions<RetryStartingAChannelEnvironmentSSandboxAsUserResponse, DefaultError, Options<RetryStartingAChannelEnvironmentSSandboxAsUserData>> => {
    const mutationOptions: UseMutationOptions<RetryStartingAChannelEnvironmentSSandboxAsUserResponse, DefaultError, Options<RetryStartingAChannelEnvironmentSSandboxAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryStartingAChannelEnvironment_sSandboxAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewCheckpointRecoveryFromAReplacedHostAsUserQueryKey = (options: Options<PreviewCheckpointRecoveryFromAReplacedHostAsUserData>) => createQueryKey('previewCheckpointRecoveryFromAReplacedHostAsUser', options);

/**
 * Preview checkpoint recovery from a replaced host
 */
export const previewCheckpointRecoveryFromAReplacedHostAsUserOptions = (options: Options<PreviewCheckpointRecoveryFromAReplacedHostAsUserData>) => queryOptions<PreviewCheckpointRecoveryFromAReplacedHostAsUserResponse, DefaultError, PreviewCheckpointRecoveryFromAReplacedHostAsUserResponse, ReturnType<typeof previewCheckpointRecoveryFromAReplacedHostAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewCheckpointRecoveryFromAReplacedHostAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewCheckpointRecoveryFromAReplacedHostAsUserQueryKey(options)
});

/**
 * Prepare checkpoint recovery from a replaced host
 */
export const prepareCheckpointRecoveryFromAReplacedHostAsUserMutation = (options?: Partial<Options<PrepareCheckpointRecoveryFromAReplacedHostAsUserData>>): UseMutationOptions<PrepareCheckpointRecoveryFromAReplacedHostAsUserResponse, DefaultError, Options<PrepareCheckpointRecoveryFromAReplacedHostAsUserData>> => {
    const mutationOptions: UseMutationOptions<PrepareCheckpointRecoveryFromAReplacedHostAsUserResponse, DefaultError, Options<PrepareCheckpointRecoveryFromAReplacedHostAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await prepareCheckpointRecoveryFromAReplacedHostAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive a channel environment
 */
export const archiveAChannelEnvironmentAsUserMutation = (options?: Partial<Options<ArchiveAChannelEnvironmentAsUserData>>): UseMutationOptions<ArchiveAChannelEnvironmentAsUserResponse, DefaultError, Options<ArchiveAChannelEnvironmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<ArchiveAChannelEnvironmentAsUserResponse, DefaultError, Options<ArchiveAChannelEnvironmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveAChannelEnvironmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mint Teams channel binding token
 */
export const mintTeamsChannelBindingTokenAsUserMutation = (options?: Partial<Options<MintTeamsChannelBindingTokenAsUserData>>): UseMutationOptions<MintTeamsChannelBindingTokenAsUserResponse, DefaultError, Options<MintTeamsChannelBindingTokenAsUserData>> => {
    const mutationOptions: UseMutationOptions<MintTeamsChannelBindingTokenAsUserResponse, DefaultError, Options<MintTeamsChannelBindingTokenAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mintTeamsChannelBindingTokenAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSelectableChannelEnvironmentProfilesAsUserQueryKey = (options?: Options<ListSelectableChannelEnvironmentProfilesAsUserData>) => createQueryKey('listSelectableChannelEnvironmentProfilesAsUser', options);

/**
 * List selectable channel environment profiles
 */
export const listSelectableChannelEnvironmentProfilesAsUserOptions = (options?: Options<ListSelectableChannelEnvironmentProfilesAsUserData>) => queryOptions<ListSelectableChannelEnvironmentProfilesAsUserResponse, DefaultError, ListSelectableChannelEnvironmentProfilesAsUserResponse, ReturnType<typeof listSelectableChannelEnvironmentProfilesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSelectableChannelEnvironmentProfilesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSelectableChannelEnvironmentProfilesAsUserQueryKey(options)
});

export const listFlowLockDiagnosticsAsUserQueryKey = (options?: Options<ListFlowLockDiagnosticsAsUserData>) => createQueryKey('listFlowLockDiagnosticsAsUser', options);

/**
 * List flow lock diagnostics
 */
export const listFlowLockDiagnosticsAsUserOptions = (options?: Options<ListFlowLockDiagnosticsAsUserData>) => queryOptions<ListFlowLockDiagnosticsAsUserResponse, DefaultError, ListFlowLockDiagnosticsAsUserResponse, ReturnType<typeof listFlowLockDiagnosticsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFlowLockDiagnosticsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowLockDiagnosticsAsUserQueryKey(options)
});

/**
 * Release flow lock
 */
export const releaseFlowLockAsUserMutation = (options?: Partial<Options<ReleaseFlowLockAsUserData>>): UseMutationOptions<ReleaseFlowLockAsUserResponse, DefaultError, Options<ReleaseFlowLockAsUserData>> => {
    const mutationOptions: UseMutationOptions<ReleaseFlowLockAsUserResponse, DefaultError, Options<ReleaseFlowLockAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await releaseFlowLockAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadCompileRecordingArtifactAsUserQueryKey = (options: Options<DownloadCompileRecordingArtifactAsUserData>) => createQueryKey('downloadCompileRecordingArtifactAsUser', options);

/**
 * Download compile recording artifact
 */
export const downloadCompileRecordingArtifactAsUserOptions = (options: Options<DownloadCompileRecordingArtifactAsUserData>) => queryOptions<DownloadCompileRecordingArtifactAsUserResponse, DefaultError, DownloadCompileRecordingArtifactAsUserResponse, ReturnType<typeof downloadCompileRecordingArtifactAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadCompileRecordingArtifactAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadCompileRecordingArtifactAsUserQueryKey(options)
});

/**
 * Retry a failed execution flow
 */
export const retryAFailedExecutionFlowAsUserMutation = (options?: Partial<Options<RetryAFailedExecutionFlowAsUserData>>): UseMutationOptions<RetryAFailedExecutionFlowAsUserResponse, DefaultError, Options<RetryAFailedExecutionFlowAsUserData>> => {
    const mutationOptions: UseMutationOptions<RetryAFailedExecutionFlowAsUserResponse, DefaultError, Options<RetryAFailedExecutionFlowAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryAFailedExecutionFlowAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a compile recording for a completed execution flow
 */
export const startACompileRecordingForACompletedExecutionFlowAsUserMutation = (options?: Partial<Options<StartACompileRecordingForACompletedExecutionFlowAsUserData>>): UseMutationOptions<StartACompileRecordingForACompletedExecutionFlowAsUserResponse, DefaultError, Options<StartACompileRecordingForACompletedExecutionFlowAsUserData>> => {
    const mutationOptions: UseMutationOptions<StartACompileRecordingForACompletedExecutionFlowAsUserResponse, DefaultError, Options<StartACompileRecordingForACompletedExecutionFlowAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startACompileRecordingForACompletedExecutionFlowAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFlowStageJournalAsUserQueryKey = (options: Options<ListFlowStageJournalAsUserData>) => createQueryKey('listFlowStageJournalAsUser', options);

/**
 * List flow stage journal
 */
export const listFlowStageJournalAsUserOptions = (options: Options<ListFlowStageJournalAsUserData>) => queryOptions<ListFlowStageJournalAsUserResponse, DefaultError, ListFlowStageJournalAsUserResponse, ReturnType<typeof listFlowStageJournalAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFlowStageJournalAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowStageJournalAsUserQueryKey(options)
});

export const listFlowStageJournalAsUserInfiniteQueryKey = (options: Options<ListFlowStageJournalAsUserData>): QueryKey<Options<ListFlowStageJournalAsUserData>> => createQueryKey('listFlowStageJournalAsUser', options, true);

/**
 * List flow stage journal
 */
export const listFlowStageJournalAsUserInfiniteOptions = (options: Options<ListFlowStageJournalAsUserData>) => infiniteQueryOptions<ListFlowStageJournalAsUserResponse, DefaultError, InfiniteData<ListFlowStageJournalAsUserResponse>, QueryKey<Options<ListFlowStageJournalAsUserData>>, string | Pick<QueryKey<Options<ListFlowStageJournalAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListFlowStageJournalAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listFlowStageJournalAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowStageJournalAsUserInfiniteQueryKey(options)
});

export const getFlowStageJournalEntryAsUserQueryKey = (options: Options<GetFlowStageJournalEntryAsUserData>) => createQueryKey('getFlowStageJournalEntryAsUser', options);

/**
 * Get flow stage journal entry
 */
export const getFlowStageJournalEntryAsUserOptions = (options: Options<GetFlowStageJournalEntryAsUserData>) => queryOptions<GetFlowStageJournalEntryAsUserResponse, DefaultError, GetFlowStageJournalEntryAsUserResponse, ReturnType<typeof getFlowStageJournalEntryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowStageJournalEntryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowStageJournalEntryAsUserQueryKey(options)
});

export const getFlowDetailsAsUserQueryKey = (options: Options<GetFlowDetailsAsUserData>) => createQueryKey('getFlowDetailsAsUser', options);

/**
 * Get flow details
 */
export const getFlowDetailsAsUserOptions = (options: Options<GetFlowDetailsAsUserData>) => queryOptions<GetFlowDetailsAsUserResponse, DefaultError, GetFlowDetailsAsUserResponse, ReturnType<typeof getFlowDetailsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowDetailsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowDetailsAsUserQueryKey(options)
});

export const getUserInstancesQueryKey = (options?: Options<GetUserInstancesData>) => createQueryKey('getUserInstances', options);

export const getUserInstancesOptions = (options?: Options<GetUserInstancesData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstances({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesQueryKey(options)
});

export const getUserInstancesByIdChannelsByChannelIdMessagesQueryKey = (options: Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>) => createQueryKey('getUserInstancesByIdChannelsByChannelIdMessages', options);

export const getUserInstancesByIdChannelsByChannelIdMessagesOptions = (options: Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdChannelsByChannelIdMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdChannelsByChannelIdMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdChannelsByChannelIdMessagesQueryKey(options)
});

export const getUserInstancesByIdChannelsByChannelIdMessagesInfiniteQueryKey = (options: Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>): QueryKey<Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>> => createQueryKey('getUserInstancesByIdChannelsByChannelIdMessages', options, true);

export const getUserInstancesByIdChannelsByChannelIdMessagesInfiniteOptions = (options: Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>) => infiniteQueryOptions<unknown, DefaultError, InfiniteData<unknown>, QueryKey<Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>>, string | Pick<QueryKey<Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetUserInstancesByIdChannelsByChannelIdMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                before: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getUserInstancesByIdChannelsByChannelIdMessages({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdChannelsByChannelIdMessagesInfiniteQueryKey(options)
});

export const getUserInstancesByIdCostQueryKey = (options: Options<GetUserInstancesByIdCostData>) => createQueryKey('getUserInstancesByIdCost', options);

export const getUserInstancesByIdCostOptions = (options: Options<GetUserInstancesByIdCostData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdCostQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdCost({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdCostQueryKey(options)
});

export const getUserInstancesByIdMemoryQueryKey = (options: Options<GetUserInstancesByIdMemoryData>) => createQueryKey('getUserInstancesByIdMemory', options);

export const getUserInstancesByIdMemoryOptions = (options: Options<GetUserInstancesByIdMemoryData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdMemoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdMemory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdMemoryQueryKey(options)
});

export const getUserInstancesByIdObservabilityListQueryKey = (options: Options<GetUserInstancesByIdObservabilityListData>) => createQueryKey('getUserInstancesByIdObservabilityList', options);

export const getUserInstancesByIdObservabilityListOptions = (options: Options<GetUserInstancesByIdObservabilityListData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdObservabilityListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdObservabilityList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdObservabilityListQueryKey(options)
});

export const getUserInstancesByIdObservabilityDiffQueryKey = (options: Options<GetUserInstancesByIdObservabilityDiffData>) => createQueryKey('getUserInstancesByIdObservabilityDiff', options);

export const getUserInstancesByIdObservabilityDiffOptions = (options: Options<GetUserInstancesByIdObservabilityDiffData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdObservabilityDiffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdObservabilityDiff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdObservabilityDiffQueryKey(options)
});

export const getUserInstancesGrowthDistributionQueryKey = (options?: Options<GetUserInstancesGrowthDistributionData>) => createQueryKey('getUserInstancesGrowthDistribution', options);

export const getUserInstancesGrowthDistributionOptions = (options?: Options<GetUserInstancesGrowthDistributionData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesGrowthDistributionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesGrowthDistribution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesGrowthDistributionQueryKey(options)
});

export const getUserInstancesByIdChannelsByChannelIdArtifactsQueryKey = (options: Options<GetUserInstancesByIdChannelsByChannelIdArtifactsData>) => createQueryKey('getUserInstancesByIdChannelsByChannelIdArtifacts', options);

export const getUserInstancesByIdChannelsByChannelIdArtifactsOptions = (options: Options<GetUserInstancesByIdChannelsByChannelIdArtifactsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getUserInstancesByIdChannelsByChannelIdArtifactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserInstancesByIdChannelsByChannelIdArtifacts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserInstancesByIdChannelsByChannelIdArtifactsQueryKey(options)
});

export const getDashboardOverviewAsUserQueryKey = (options?: Options<GetDashboardOverviewAsUserData>) => createQueryKey('getDashboardOverviewAsUser', options);

/**
 * Get dashboard overview
 */
export const getDashboardOverviewAsUserOptions = (options?: Options<GetDashboardOverviewAsUserData>) => queryOptions<GetDashboardOverviewAsUserResponse, DefaultError, GetDashboardOverviewAsUserResponse, ReturnType<typeof getDashboardOverviewAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboardOverviewAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardOverviewAsUserQueryKey(options)
});

export const listTasksAsUserQueryKey = (options?: Options<ListTasksAsUserData>) => createQueryKey('listTasksAsUser', options);

/**
 * List tasks
 */
export const listTasksAsUserOptions = (options?: Options<ListTasksAsUserData>) => queryOptions<ListTasksAsUserResponse, DefaultError, ListTasksAsUserResponse, ReturnType<typeof listTasksAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTasksAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTasksAsUserQueryKey(options)
});

export const listTasksAsUserInfiniteQueryKey = (options?: Options<ListTasksAsUserData>): QueryKey<Options<ListTasksAsUserData>> => createQueryKey('listTasksAsUser', options, true);

/**
 * List tasks
 */
export const listTasksAsUserInfiniteOptions = (options?: Options<ListTasksAsUserData>) => infiniteQueryOptions<ListTasksAsUserResponse, DefaultError, InfiniteData<ListTasksAsUserResponse>, QueryKey<Options<ListTasksAsUserData>>, string | Pick<QueryKey<Options<ListTasksAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTasksAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTasksAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTasksAsUserInfiniteQueryKey(options)
});

export const getTaskFacetsAsUserQueryKey = (options?: Options<GetTaskFacetsAsUserData>) => createQueryKey('getTaskFacetsAsUser', options);

/**
 * Get task facets
 */
export const getTaskFacetsAsUserOptions = (options?: Options<GetTaskFacetsAsUserData>) => queryOptions<GetTaskFacetsAsUserResponse, DefaultError, GetTaskFacetsAsUserResponse, ReturnType<typeof getTaskFacetsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskFacetsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskFacetsAsUserQueryKey(options)
});

/**
 * Cancel tasks
 */
export const cancelTasksAsUserMutation = (options?: Partial<Options<CancelTasksAsUserData>>): UseMutationOptions<CancelTasksAsUserResponse, DefaultError, Options<CancelTasksAsUserData>> => {
    const mutationOptions: UseMutationOptions<CancelTasksAsUserResponse, DefaultError, Options<CancelTasksAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelTasksAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskDetailsAsUserQueryKey = (options: Options<GetTaskDetailsAsUserData>) => createQueryKey('getTaskDetailsAsUser', options);

/**
 * Get task details
 */
export const getTaskDetailsAsUserOptions = (options: Options<GetTaskDetailsAsUserData>) => queryOptions<GetTaskDetailsAsUserResponse, DefaultError, GetTaskDetailsAsUserResponse, ReturnType<typeof getTaskDetailsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskDetailsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskDetailsAsUserQueryKey(options)
});

export const getTaskEventsAsUserQueryKey = (options: Options<GetTaskEventsAsUserData>) => createQueryKey('getTaskEventsAsUser', options);

/**
 * Get task events
 */
export const getTaskEventsAsUserOptions = (options: Options<GetTaskEventsAsUserData>) => queryOptions<GetTaskEventsAsUserResponse, DefaultError, GetTaskEventsAsUserResponse, ReturnType<typeof getTaskEventsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskEventsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskEventsAsUserQueryKey(options)
});

export const getTaskLogsAsUserQueryKey = (options: Options<GetTaskLogsAsUserData>) => createQueryKey('getTaskLogsAsUser', options);

/**
 * Get task logs
 */
export const getTaskLogsAsUserOptions = (options: Options<GetTaskLogsAsUserData>) => queryOptions<GetTaskLogsAsUserResponse, DefaultError, GetTaskLogsAsUserResponse, ReturnType<typeof getTaskLogsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskLogsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskLogsAsUserQueryKey(options)
});

export const getTeamsIntegrationStatusAsUserQueryKey = (options?: Options<GetTeamsIntegrationStatusAsUserData>) => createQueryKey('getTeamsIntegrationStatusAsUser', options);

/**
 * Get Teams integration status
 */
export const getTeamsIntegrationStatusAsUserOptions = (options?: Options<GetTeamsIntegrationStatusAsUserData>) => queryOptions<GetTeamsIntegrationStatusAsUserResponse, DefaultError, GetTeamsIntegrationStatusAsUserResponse, ReturnType<typeof getTeamsIntegrationStatusAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamsIntegrationStatusAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamsIntegrationStatusAsUserQueryKey(options)
});

export const getPlanRevisionTelemetryAsUserQueryKey = (options: Options<GetPlanRevisionTelemetryAsUserData>) => createQueryKey('getPlanRevisionTelemetryAsUser', options);

/**
 * Get plan revision telemetry
 */
export const getPlanRevisionTelemetryAsUserOptions = (options: Options<GetPlanRevisionTelemetryAsUserData>) => queryOptions<GetPlanRevisionTelemetryAsUserResponse, DefaultError, GetPlanRevisionTelemetryAsUserResponse, ReturnType<typeof getPlanRevisionTelemetryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanRevisionTelemetryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanRevisionTelemetryAsUserQueryKey(options)
});

export const getPlanRevisionGraphAsUserQueryKey = (options: Options<GetPlanRevisionGraphAsUserData>) => createQueryKey('getPlanRevisionGraphAsUser', options);

/**
 * Get plan revision graph
 */
export const getPlanRevisionGraphAsUserOptions = (options: Options<GetPlanRevisionGraphAsUserData>) => queryOptions<GetPlanRevisionGraphAsUserResponse, DefaultError, GetPlanRevisionGraphAsUserResponse, ReturnType<typeof getPlanRevisionGraphAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanRevisionGraphAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanRevisionGraphAsUserQueryKey(options)
});

export const listRecentPlanSnapshotsAsUserQueryKey = (options?: Options<ListRecentPlanSnapshotsAsUserData>) => createQueryKey('listRecentPlanSnapshotsAsUser', options);

/**
 * List recent plan snapshots
 */
export const listRecentPlanSnapshotsAsUserOptions = (options?: Options<ListRecentPlanSnapshotsAsUserData>) => queryOptions<ListRecentPlanSnapshotsAsUserResponse, DefaultError, ListRecentPlanSnapshotsAsUserResponse, ReturnType<typeof listRecentPlanSnapshotsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRecentPlanSnapshotsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRecentPlanSnapshotsAsUserQueryKey(options)
});

export const getPlanSnapshotByStoryIssueKeyAsUserQueryKey = (options: Options<GetPlanSnapshotByStoryIssueKeyAsUserData>) => createQueryKey('getPlanSnapshotByStoryIssueKeyAsUser', options);

/**
 * Get plan snapshot by story issue key
 */
export const getPlanSnapshotByStoryIssueKeyAsUserOptions = (options: Options<GetPlanSnapshotByStoryIssueKeyAsUserData>) => queryOptions<GetPlanSnapshotByStoryIssueKeyAsUserResponse, DefaultError, GetPlanSnapshotByStoryIssueKeyAsUserResponse, ReturnType<typeof getPlanSnapshotByStoryIssueKeyAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanSnapshotByStoryIssueKeyAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanSnapshotByStoryIssueKeyAsUserQueryKey(options)
});

export const getPlanSnapshotByIssueKeyAsUserQueryKey = (options: Options<GetPlanSnapshotByIssueKeyAsUserData>) => createQueryKey('getPlanSnapshotByIssueKeyAsUser', options);

/**
 * Get plan snapshot by issue key
 */
export const getPlanSnapshotByIssueKeyAsUserOptions = (options: Options<GetPlanSnapshotByIssueKeyAsUserData>) => queryOptions<GetPlanSnapshotByIssueKeyAsUserResponse, DefaultError, GetPlanSnapshotByIssueKeyAsUserResponse, ReturnType<typeof getPlanSnapshotByIssueKeyAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanSnapshotByIssueKeyAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanSnapshotByIssueKeyAsUserQueryKey(options)
});

export const getPlanSnapshotByIdAsUserQueryKey = (options: Options<GetPlanSnapshotByIdAsUserData>) => createQueryKey('getPlanSnapshotByIdAsUser', options);

/**
 * Get plan snapshot by ID
 */
export const getPlanSnapshotByIdAsUserOptions = (options: Options<GetPlanSnapshotByIdAsUserData>) => queryOptions<GetPlanSnapshotByIdAsUserResponse, DefaultError, GetPlanSnapshotByIdAsUserResponse, ReturnType<typeof getPlanSnapshotByIdAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanSnapshotByIdAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanSnapshotByIdAsUserQueryKey(options)
});

export const listAgentModeBudgetsAsUserQueryKey = (options?: Options<ListAgentModeBudgetsAsUserData>) => createQueryKey('listAgentModeBudgetsAsUser', options);

/**
 * List agent mode budgets
 */
export const listAgentModeBudgetsAsUserOptions = (options?: Options<ListAgentModeBudgetsAsUserData>) => queryOptions<ListAgentModeBudgetsAsUserResponse, DefaultError, ListAgentModeBudgetsAsUserResponse, ReturnType<typeof listAgentModeBudgetsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentModeBudgetsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentModeBudgetsAsUserQueryKey(options)
});

/**
 * Upsert agent mode budgets
 */
export const upsertAgentModeBudgetsAsUserMutation = (options?: Partial<Options<UpsertAgentModeBudgetsAsUserData>>): UseMutationOptions<UpsertAgentModeBudgetsAsUserResponse, DefaultError, Options<UpsertAgentModeBudgetsAsUserData>> => {
    const mutationOptions: UseMutationOptions<UpsertAgentModeBudgetsAsUserResponse, DefaultError, Options<UpsertAgentModeBudgetsAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertAgentModeBudgetsAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Select organization
 */
export const selectOrganizationAsUserMutation = (options?: Partial<Options<SelectOrganizationAsUserData>>): UseMutationOptions<SelectOrganizationAsUserResponse, DefaultError, Options<SelectOrganizationAsUserData>> => {
    const mutationOptions: UseMutationOptions<SelectOrganizationAsUserResponse, DefaultError, Options<SelectOrganizationAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await selectOrganizationAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConnectedMcpOauthGrantsAsUserQueryKey = (options?: Options<ListConnectedMcpOauthGrantsAsUserData>) => createQueryKey('listConnectedMcpOauthGrantsAsUser', options);

/**
 * List connected MCP OAuth grants
 */
export const listConnectedMcpOauthGrantsAsUserOptions = (options?: Options<ListConnectedMcpOauthGrantsAsUserData>) => queryOptions<ListConnectedMcpOauthGrantsAsUserResponse, DefaultError, ListConnectedMcpOauthGrantsAsUserResponse, ReturnType<typeof listConnectedMcpOauthGrantsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectedMcpOauthGrantsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectedMcpOauthGrantsAsUserQueryKey(options)
});

export const listMcpAccessTokensAsUserQueryKey = (options?: Options<ListMcpAccessTokensAsUserData>) => createQueryKey('listMcpAccessTokensAsUser', options);

/**
 * List MCP access tokens
 */
export const listMcpAccessTokensAsUserOptions = (options?: Options<ListMcpAccessTokensAsUserData>) => queryOptions<ListMcpAccessTokensAsUserResponse, DefaultError, ListMcpAccessTokensAsUserResponse, ReturnType<typeof listMcpAccessTokensAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMcpAccessTokensAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMcpAccessTokensAsUserQueryKey(options)
});

/**
 * Create MCP access token
 */
export const createMcpAccessTokenAsUserMutation = (options?: Partial<Options<CreateMcpAccessTokenAsUserData>>): UseMutationOptions<CreateMcpAccessTokenAsUserResponse, DefaultError, Options<CreateMcpAccessTokenAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateMcpAccessTokenAsUserResponse, DefaultError, Options<CreateMcpAccessTokenAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMcpAccessTokenAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke MCP OAuth grant
 */
export const revokeMcpOauthGrantAsUserMutation = (options?: Partial<Options<RevokeMcpOauthGrantAsUserData>>): UseMutationOptions<RevokeMcpOauthGrantAsUserResponse, DefaultError, Options<RevokeMcpOauthGrantAsUserData>> => {
    const mutationOptions: UseMutationOptions<RevokeMcpOauthGrantAsUserResponse, DefaultError, Options<RevokeMcpOauthGrantAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeMcpOauthGrantAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke MCP access token
 */
export const revokeMcpAccessTokenAsUserMutation = (options?: Partial<Options<RevokeMcpAccessTokenAsUserData>>): UseMutationOptions<RevokeMcpAccessTokenAsUserResponse, DefaultError, Options<RevokeMcpAccessTokenAsUserData>> => {
    const mutationOptions: UseMutationOptions<RevokeMcpAccessTokenAsUserResponse, DefaultError, Options<RevokeMcpAccessTokenAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeMcpAccessTokenAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationMcpServersAsUserQueryKey = (options?: Options<ListOrganizationMcpServersAsUserData>) => createQueryKey('listOrganizationMcpServersAsUser', options);

/**
 * List organization MCP servers
 */
export const listOrganizationMcpServersAsUserOptions = (options?: Options<ListOrganizationMcpServersAsUserData>) => queryOptions<ListOrganizationMcpServersAsUserResponse, DefaultError, ListOrganizationMcpServersAsUserResponse, ReturnType<typeof listOrganizationMcpServersAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationMcpServersAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationMcpServersAsUserQueryKey(options)
});

/**
 * Register an MCP server for the organization
 */
export const registerAnMcpServerForTheOrganizationAsUserMutation = (options?: Partial<Options<RegisterAnMcpServerForTheOrganizationAsUserData>>): UseMutationOptions<RegisterAnMcpServerForTheOrganizationAsUserResponse, DefaultError, Options<RegisterAnMcpServerForTheOrganizationAsUserData>> => {
    const mutationOptions: UseMutationOptions<RegisterAnMcpServerForTheOrganizationAsUserResponse, DefaultError, Options<RegisterAnMcpServerForTheOrganizationAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerAnMcpServerForTheOrganizationAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove an organization MCP server
 */
export const removeAnOrganizationMcpServerAsUserMutation = (options?: Partial<Options<RemoveAnOrganizationMcpServerAsUserData>>): UseMutationOptions<RemoveAnOrganizationMcpServerAsUserResponse, DefaultError, Options<RemoveAnOrganizationMcpServerAsUserData>> => {
    const mutationOptions: UseMutationOptions<RemoveAnOrganizationMcpServerAsUserResponse, DefaultError, Options<RemoveAnOrganizationMcpServerAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeAnOrganizationMcpServerAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an organization MCP server
 */
export const updateAnOrganizationMcpServerAsUserMutation = (options?: Partial<Options<UpdateAnOrganizationMcpServerAsUserData>>): UseMutationOptions<UpdateAnOrganizationMcpServerAsUserResponse, DefaultError, Options<UpdateAnOrganizationMcpServerAsUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateAnOrganizationMcpServerAsUserResponse, DefaultError, Options<UpdateAnOrganizationMcpServerAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAnOrganizationMcpServerAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationsAsUserQueryKey = (options?: Options<ListOrganizationsAsUserData>) => createQueryKey('listOrganizationsAsUser', options);

/**
 * List organizations
 */
export const listOrganizationsAsUserOptions = (options?: Options<ListOrganizationsAsUserData>) => queryOptions<ListOrganizationsAsUserResponse, DefaultError, ListOrganizationsAsUserResponse, ReturnType<typeof listOrganizationsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsAsUserQueryKey(options)
});

/**
 * Create organization
 */
export const createOrganizationAsUserMutation = (options?: Partial<Options<CreateOrganizationAsUserData>>): UseMutationOptions<CreateOrganizationAsUserResponse, DefaultError, Options<CreateOrganizationAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationAsUserResponse, DefaultError, Options<CreateOrganizationAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganizationAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationApiKeysAsUserQueryKey = (options: Options<ListOrganizationApiKeysAsUserData>) => createQueryKey('listOrganizationApiKeysAsUser', options);

/**
 * List organization API keys
 */
export const listOrganizationApiKeysAsUserOptions = (options: Options<ListOrganizationApiKeysAsUserData>) => queryOptions<ListOrganizationApiKeysAsUserResponse, DefaultError, ListOrganizationApiKeysAsUserResponse, ReturnType<typeof listOrganizationApiKeysAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationApiKeysAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationApiKeysAsUserQueryKey(options)
});

/**
 * Set up organization billing
 */
export const setUpOrganizationBillingAsUserMutation = (options?: Partial<Options<SetUpOrganizationBillingAsUserData>>): UseMutationOptions<SetUpOrganizationBillingAsUserResponse, DefaultError, Options<SetUpOrganizationBillingAsUserData>> => {
    const mutationOptions: UseMutationOptions<SetUpOrganizationBillingAsUserResponse, DefaultError, Options<SetUpOrganizationBillingAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUpOrganizationBillingAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create topup session
 */
export const createTopupSessionAsUserMutation = (options?: Partial<Options<CreateTopupSessionAsUserData>>): UseMutationOptions<CreateTopupSessionAsUserResponse, DefaultError, Options<CreateTopupSessionAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateTopupSessionAsUserResponse, DefaultError, Options<CreateTopupSessionAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTopupSessionAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBillingBalanceAsUserQueryKey = (options: Options<GetBillingBalanceAsUserData>) => createQueryKey('getBillingBalanceAsUser', options);

/**
 * Get billing balance
 */
export const getBillingBalanceAsUserOptions = (options: Options<GetBillingBalanceAsUserData>) => queryOptions<GetBillingBalanceAsUserResponse, DefaultError, GetBillingBalanceAsUserResponse, ReturnType<typeof getBillingBalanceAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBillingBalanceAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBillingBalanceAsUserQueryKey(options)
});

export const listBillingTransactionsAsUserQueryKey = (options: Options<ListBillingTransactionsAsUserData>) => createQueryKey('listBillingTransactionsAsUser', options);

/**
 * List billing transactions
 */
export const listBillingTransactionsAsUserOptions = (options: Options<ListBillingTransactionsAsUserData>) => queryOptions<ListBillingTransactionsAsUserResponse, DefaultError, ListBillingTransactionsAsUserResponse, ReturnType<typeof listBillingTransactionsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBillingTransactionsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBillingTransactionsAsUserQueryKey(options)
});

export const listBillingTransactionsAsUserInfiniteQueryKey = (options: Options<ListBillingTransactionsAsUserData>): QueryKey<Options<ListBillingTransactionsAsUserData>> => createQueryKey('listBillingTransactionsAsUser', options, true);

/**
 * List billing transactions
 */
export const listBillingTransactionsAsUserInfiniteOptions = (options: Options<ListBillingTransactionsAsUserData>) => infiniteQueryOptions<ListBillingTransactionsAsUserResponse, DefaultError, InfiniteData<ListBillingTransactionsAsUserResponse>, QueryKey<Options<ListBillingTransactionsAsUserData>>, number | Pick<QueryKey<Options<ListBillingTransactionsAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListBillingTransactionsAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listBillingTransactionsAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBillingTransactionsAsUserInfiniteQueryKey(options)
});

/**
 * Create billing portal session
 */
export const createBillingPortalSessionAsUserMutation = (options?: Partial<Options<CreateBillingPortalSessionAsUserData>>): UseMutationOptions<CreateBillingPortalSessionAsUserResponse, DefaultError, Options<CreateBillingPortalSessionAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateBillingPortalSessionAsUserResponse, DefaultError, Options<CreateBillingPortalSessionAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBillingPortalSessionAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationInvitesAsUserQueryKey = (options: Options<ListOrganizationInvitesAsUserData>) => createQueryKey('listOrganizationInvitesAsUser', options);

/**
 * List organization invites
 */
export const listOrganizationInvitesAsUserOptions = (options: Options<ListOrganizationInvitesAsUserData>) => queryOptions<ListOrganizationInvitesAsUserResponse, DefaultError, ListOrganizationInvitesAsUserResponse, ReturnType<typeof listOrganizationInvitesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationInvitesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationInvitesAsUserQueryKey(options)
});

/**
 * Invalidate organization invite
 */
export const invalidateOrganizationInviteAsUserMutation = (options?: Partial<Options<InvalidateOrganizationInviteAsUserData>>): UseMutationOptions<InvalidateOrganizationInviteAsUserResponse, DefaultError, Options<InvalidateOrganizationInviteAsUserData>> => {
    const mutationOptions: UseMutationOptions<InvalidateOrganizationInviteAsUserResponse, DefaultError, Options<InvalidateOrganizationInviteAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invalidateOrganizationInviteAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationMembersAsUserQueryKey = (options: Options<ListOrganizationMembersAsUserData>) => createQueryKey('listOrganizationMembersAsUser', options);

/**
 * List organization members
 */
export const listOrganizationMembersAsUserOptions = (options: Options<ListOrganizationMembersAsUserData>) => queryOptions<ListOrganizationMembersAsUserResponse, DefaultError, ListOrganizationMembersAsUserResponse, ReturnType<typeof listOrganizationMembersAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationMembersAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationMembersAsUserQueryKey(options)
});

/**
 * Invite organization member
 */
export const inviteOrganizationMemberAsUserMutation = (options?: Partial<Options<InviteOrganizationMemberAsUserData>>): UseMutationOptions<InviteOrganizationMemberAsUserResponse, DefaultError, Options<InviteOrganizationMemberAsUserData>> => {
    const mutationOptions: UseMutationOptions<InviteOrganizationMemberAsUserResponse, DefaultError, Options<InviteOrganizationMemberAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inviteOrganizationMemberAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove member
 */
export const removeMemberAsUserMutation = (options?: Partial<Options<RemoveMemberAsUserData>>): UseMutationOptions<RemoveMemberAsUserResponse, DefaultError, Options<RemoveMemberAsUserData>> => {
    const mutationOptions: UseMutationOptions<RemoveMemberAsUserResponse, DefaultError, Options<RemoveMemberAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMemberAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update member role
 */
export const updateMemberRoleAsUserMutation = (options?: Partial<Options<UpdateMemberRoleAsUserData>>): UseMutationOptions<UpdateMemberRoleAsUserResponse, DefaultError, Options<UpdateMemberRoleAsUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateMemberRoleAsUserResponse, DefaultError, Options<UpdateMemberRoleAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMemberRoleAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationAsUserQueryKey = (options: Options<GetOrganizationAsUserData>) => createQueryKey('getOrganizationAsUser', options);

/**
 * Get organization
 */
export const getOrganizationAsUserOptions = (options: Options<GetOrganizationAsUserData>) => queryOptions<GetOrganizationAsUserResponse, DefaultError, GetOrganizationAsUserResponse, ReturnType<typeof getOrganizationAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationAsUserQueryKey(options)
});

export const listPendingInvitesAsUserQueryKey = (options?: Options<ListPendingInvitesAsUserData>) => createQueryKey('listPendingInvitesAsUser', options);

/**
 * List pending invites
 */
export const listPendingInvitesAsUserOptions = (options?: Options<ListPendingInvitesAsUserData>) => queryOptions<ListPendingInvitesAsUserResponse, DefaultError, ListPendingInvitesAsUserResponse, ReturnType<typeof listPendingInvitesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPendingInvitesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPendingInvitesAsUserQueryKey(options)
});

export const getInviteByTokenAsUserQueryKey = (options: Options<GetInviteByTokenAsUserData>) => createQueryKey('getInviteByTokenAsUser', options);

/**
 * Get invite by token
 */
export const getInviteByTokenAsUserOptions = (options: Options<GetInviteByTokenAsUserData>) => queryOptions<GetInviteByTokenAsUserResponse, DefaultError, GetInviteByTokenAsUserResponse, ReturnType<typeof getInviteByTokenAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInviteByTokenAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInviteByTokenAsUserQueryKey(options)
});

/**
 * Accept invite
 */
export const acceptInviteAsUserMutation = (options?: Partial<Options<AcceptInviteAsUserData>>): UseMutationOptions<AcceptInviteAsUserResponse, DefaultError, Options<AcceptInviteAsUserData>> => {
    const mutationOptions: UseMutationOptions<AcceptInviteAsUserResponse, DefaultError, Options<AcceptInviteAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInviteAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decline invite
 */
export const declineInviteAsUserMutation = (options?: Partial<Options<DeclineInviteAsUserData>>): UseMutationOptions<DeclineInviteAsUserResponse, DefaultError, Options<DeclineInviteAsUserData>> => {
    const mutationOptions: UseMutationOptions<DeclineInviteAsUserResponse, DefaultError, Options<DeclineInviteAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await declineInviteAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIssueIntegrationProvidersAsUserQueryKey = (options?: Options<ListIssueIntegrationProvidersAsUserData>) => createQueryKey('listIssueIntegrationProvidersAsUser', options);

/**
 * List issue integration providers
 */
export const listIssueIntegrationProvidersAsUserOptions = (options?: Options<ListIssueIntegrationProvidersAsUserData>) => queryOptions<ListIssueIntegrationProvidersAsUserResponse, DefaultError, ListIssueIntegrationProvidersAsUserResponse, ReturnType<typeof listIssueIntegrationProvidersAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIssueIntegrationProvidersAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIssueIntegrationProvidersAsUserQueryKey(options)
});

export const getIssueIntegrationProviderDetailAsUserQueryKey = (options: Options<GetIssueIntegrationProviderDetailAsUserData>) => createQueryKey('getIssueIntegrationProviderDetailAsUser', options);

/**
 * Get issue integration provider detail
 */
export const getIssueIntegrationProviderDetailAsUserOptions = (options: Options<GetIssueIntegrationProviderDetailAsUserData>) => queryOptions<GetIssueIntegrationProviderDetailAsUserResponse, DefaultError, GetIssueIntegrationProviderDetailAsUserResponse, ReturnType<typeof getIssueIntegrationProviderDetailAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIssueIntegrationProviderDetailAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIssueIntegrationProviderDetailAsUserQueryKey(options)
});

/**
 * Create issue integration project
 */
export const createIssueIntegrationProjectAsUserMutation = (options?: Partial<Options<CreateIssueIntegrationProjectAsUserData>>): UseMutationOptions<CreateIssueIntegrationProjectAsUserResponse, DefaultError, Options<CreateIssueIntegrationProjectAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateIssueIntegrationProjectAsUserResponse, DefaultError, Options<CreateIssueIntegrationProjectAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIssueIntegrationProjectAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const discoverRemoteIssueProjectsAsUserQueryKey = (options: Options<DiscoverRemoteIssueProjectsAsUserData>) => createQueryKey('discoverRemoteIssueProjectsAsUser', options);

/**
 * Discover remote issue projects
 */
export const discoverRemoteIssueProjectsAsUserOptions = (options: Options<DiscoverRemoteIssueProjectsAsUserData>) => queryOptions<DiscoverRemoteIssueProjectsAsUserResponse, DefaultError, DiscoverRemoteIssueProjectsAsUserResponse, ReturnType<typeof discoverRemoteIssueProjectsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await discoverRemoteIssueProjectsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: discoverRemoteIssueProjectsAsUserQueryKey(options)
});

export const issueIntegrationOauthCallbackAsUserQueryKey = (options: Options<IssueIntegrationOauthCallbackAsUserData>) => createQueryKey('issueIntegrationOauthCallbackAsUser', options);

/**
 * Issue integration OAuth callback
 */
export const issueIntegrationOauthCallbackAsUserOptions = (options: Options<IssueIntegrationOauthCallbackAsUserData>) => queryOptions<IssueIntegrationOauthCallbackAsUserResponse, DefaultError, IssueIntegrationOauthCallbackAsUserResponse, ReturnType<typeof issueIntegrationOauthCallbackAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await issueIntegrationOauthCallbackAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: issueIntegrationOauthCallbackAsUserQueryKey(options)
});

/**
 * Generate Jira link code
 */
export const generateJiraLinkCodeAsUserMutation = (options?: Partial<Options<GenerateJiraLinkCodeAsUserData>>): UseMutationOptions<GenerateJiraLinkCodeAsUserResponse, DefaultError, Options<GenerateJiraLinkCodeAsUserData>> => {
    const mutationOptions: UseMutationOptions<GenerateJiraLinkCodeAsUserResponse, DefaultError, Options<GenerateJiraLinkCodeAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateJiraLinkCodeAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Launch or resume a channel workspace from an issue
 */
export const launchOrResumeAChannelWorkspaceFromAnIssueAsUserMutation = (options?: Partial<Options<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData>>): UseMutationOptions<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserResponse, DefaultError, Options<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData>> => {
    const mutationOptions: UseMutationOptions<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserResponse, DefaultError, Options<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await launchOrResumeAChannelWorkspaceFromAnIssueAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Permanently delete an issue workspace aggregate
 */
export const permanentlyDeleteAnIssueWorkspaceAggregateAsUserMutation = (options?: Partial<Options<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData>>): UseMutationOptions<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserResponse, DefaultError, Options<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData>> => {
    const mutationOptions: UseMutationOptions<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserResponse, DefaultError, Options<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await permanentlyDeleteAnIssueWorkspaceAggregateAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrSearchIssuesUsingStructuredFiltersAsUserQueryKey = (options?: Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>) => createQueryKey('listOrSearchIssuesUsingStructuredFiltersAsUser', options);

/**
 * List or search issues using structured filters
 */
export const listOrSearchIssuesUsingStructuredFiltersAsUserOptions = (options?: Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>) => queryOptions<ListOrSearchIssuesUsingStructuredFiltersAsUserResponse, DefaultError, ListOrSearchIssuesUsingStructuredFiltersAsUserResponse, ReturnType<typeof listOrSearchIssuesUsingStructuredFiltersAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrSearchIssuesUsingStructuredFiltersAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrSearchIssuesUsingStructuredFiltersAsUserQueryKey(options)
});

export const listOrSearchIssuesUsingStructuredFiltersAsUserInfiniteQueryKey = (options?: Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>): QueryKey<Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>> => createQueryKey('listOrSearchIssuesUsingStructuredFiltersAsUser', options, true);

/**
 * List or search issues using structured filters
 */
export const listOrSearchIssuesUsingStructuredFiltersAsUserInfiniteOptions = (options?: Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>) => infiniteQueryOptions<ListOrSearchIssuesUsingStructuredFiltersAsUserResponse, DefaultError, InfiniteData<ListOrSearchIssuesUsingStructuredFiltersAsUserResponse>, QueryKey<Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>>, string | Pick<QueryKey<Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listOrSearchIssuesUsingStructuredFiltersAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrSearchIssuesUsingStructuredFiltersAsUserInfiniteQueryKey(options)
});

export const getIssueDetailsAsUserQueryKey = (options: Options<GetIssueDetailsAsUserData>) => createQueryKey('getIssueDetailsAsUser', options);

/**
 * Get issue details
 */
export const getIssueDetailsAsUserOptions = (options: Options<GetIssueDetailsAsUserData>) => queryOptions<GetIssueDetailsAsUserResponse, DefaultError, GetIssueDetailsAsUserResponse, ReturnType<typeof getIssueDetailsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIssueDetailsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIssueDetailsAsUserQueryKey(options)
});

export const listSourceControlProvidersAsUserQueryKey = (options?: Options<ListSourceControlProvidersAsUserData>) => createQueryKey('listSourceControlProvidersAsUser', options);

/**
 * List source control providers
 */
export const listSourceControlProvidersAsUserOptions = (options?: Options<ListSourceControlProvidersAsUserData>) => queryOptions<ListSourceControlProvidersAsUserResponse, DefaultError, ListSourceControlProvidersAsUserResponse, ReturnType<typeof listSourceControlProvidersAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSourceControlProvidersAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourceControlProvidersAsUserQueryKey(options)
});

/**
 * Create source control provider
 */
export const createSourceControlProviderAsUserMutation = (options?: Partial<Options<CreateSourceControlProviderAsUserData>>): UseMutationOptions<CreateSourceControlProviderAsUserResponse, DefaultError, Options<CreateSourceControlProviderAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateSourceControlProviderAsUserResponse, DefaultError, Options<CreateSourceControlProviderAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSourceControlProviderAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSourceControlProviderDetailAsUserQueryKey = (options: Options<GetSourceControlProviderDetailAsUserData>) => createQueryKey('getSourceControlProviderDetailAsUser', options);

/**
 * Get source control provider detail
 */
export const getSourceControlProviderDetailAsUserOptions = (options: Options<GetSourceControlProviderDetailAsUserData>) => queryOptions<GetSourceControlProviderDetailAsUserResponse, DefaultError, GetSourceControlProviderDetailAsUserResponse, ReturnType<typeof getSourceControlProviderDetailAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSourceControlProviderDetailAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSourceControlProviderDetailAsUserQueryKey(options)
});

export const discoverRemoteRepositoriesAsUserQueryKey = (options: Options<DiscoverRemoteRepositoriesAsUserData>) => createQueryKey('discoverRemoteRepositoriesAsUser', options);

/**
 * Discover remote repositories
 */
export const discoverRemoteRepositoriesAsUserOptions = (options: Options<DiscoverRemoteRepositoriesAsUserData>) => queryOptions<DiscoverRemoteRepositoriesAsUserResponse, DefaultError, DiscoverRemoteRepositoriesAsUserResponse, ReturnType<typeof discoverRemoteRepositoriesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await discoverRemoteRepositoriesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: discoverRemoteRepositoriesAsUserQueryKey(options)
});

export const discoverRemoteBranchesAsUserQueryKey = (options: Options<DiscoverRemoteBranchesAsUserData>) => createQueryKey('discoverRemoteBranchesAsUser', options);

/**
 * Discover remote branches
 */
export const discoverRemoteBranchesAsUserOptions = (options: Options<DiscoverRemoteBranchesAsUserData>) => queryOptions<DiscoverRemoteBranchesAsUserResponse, DefaultError, DiscoverRemoteBranchesAsUserResponse, ReturnType<typeof discoverRemoteBranchesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await discoverRemoteBranchesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: discoverRemoteBranchesAsUserQueryKey(options)
});

/**
 * Create source control credential
 */
export const createSourceControlCredentialAsUserMutation = (options?: Partial<Options<CreateSourceControlCredentialAsUserData>>): UseMutationOptions<CreateSourceControlCredentialAsUserResponse, DefaultError, Options<CreateSourceControlCredentialAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateSourceControlCredentialAsUserResponse, DefaultError, Options<CreateSourceControlCredentialAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSourceControlCredentialAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify source control credential
 */
export const verifySourceControlCredentialAsUserMutation = (options?: Partial<Options<VerifySourceControlCredentialAsUserData>>): UseMutationOptions<VerifySourceControlCredentialAsUserResponse, DefaultError, Options<VerifySourceControlCredentialAsUserData>> => {
    const mutationOptions: UseMutationOptions<VerifySourceControlCredentialAsUserResponse, DefaultError, Options<VerifySourceControlCredentialAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifySourceControlCredentialAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update source control credential
 */
export const updateSourceControlCredentialAsUserMutation = (options?: Partial<Options<UpdateSourceControlCredentialAsUserData>>): UseMutationOptions<UpdateSourceControlCredentialAsUserResponse, DefaultError, Options<UpdateSourceControlCredentialAsUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateSourceControlCredentialAsUserResponse, DefaultError, Options<UpdateSourceControlCredentialAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSourceControlCredentialAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert source control repositories
 */
export const upsertSourceControlRepositoriesAsUserMutation = (options?: Partial<Options<UpsertSourceControlRepositoriesAsUserData>>): UseMutationOptions<UpsertSourceControlRepositoriesAsUserResponse, DefaultError, Options<UpsertSourceControlRepositoriesAsUserData>> => {
    const mutationOptions: UseMutationOptions<UpsertSourceControlRepositoriesAsUserResponse, DefaultError, Options<UpsertSourceControlRepositoriesAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertSourceControlRepositoriesAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete source control webhook
 */
export const deleteSourceControlWebhookAsUserMutation = (options?: Partial<Options<DeleteSourceControlWebhookAsUserData>>): UseMutationOptions<DeleteSourceControlWebhookAsUserResponse, DefaultError, Options<DeleteSourceControlWebhookAsUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteSourceControlWebhookAsUserResponse, DefaultError, Options<DeleteSourceControlWebhookAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSourceControlWebhookAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Setup GitHub org webhook
 */
export const setupGithubOrgWebhookAsUserMutation = (options?: Partial<Options<SetupGithubOrgWebhookAsUserData>>): UseMutationOptions<SetupGithubOrgWebhookAsUserResponse, DefaultError, Options<SetupGithubOrgWebhookAsUserData>> => {
    const mutationOptions: UseMutationOptions<SetupGithubOrgWebhookAsUserResponse, DefaultError, Options<SetupGithubOrgWebhookAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setupGithubOrgWebhookAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Setup GitHub App installation
 */
export const setupGithubAppInstallationAsUserMutation = (options?: Partial<Options<SetupGithubAppInstallationAsUserData>>): UseMutationOptions<SetupGithubAppInstallationAsUserResponse, DefaultError, Options<SetupGithubAppInstallationAsUserData>> => {
    const mutationOptions: UseMutationOptions<SetupGithubAppInstallationAsUserResponse, DefaultError, Options<SetupGithubAppInstallationAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setupGithubAppInstallationAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete source control credential
 */
export const deleteSourceControlCredentialAsUserMutation = (options?: Partial<Options<DeleteSourceControlCredentialAsUserData>>): UseMutationOptions<DeleteSourceControlCredentialAsUserResponse, DefaultError, Options<DeleteSourceControlCredentialAsUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteSourceControlCredentialAsUserResponse, DefaultError, Options<DeleteSourceControlCredentialAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSourceControlCredentialAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSourceControlRepositorySummariesAsUserQueryKey = (options?: Options<ListSourceControlRepositorySummariesAsUserData>) => createQueryKey('listSourceControlRepositorySummariesAsUser', options);

/**
 * List source control repository summaries
 */
export const listSourceControlRepositorySummariesAsUserOptions = (options?: Options<ListSourceControlRepositorySummariesAsUserData>) => queryOptions<ListSourceControlRepositorySummariesAsUserResponse, DefaultError, ListSourceControlRepositorySummariesAsUserResponse, ReturnType<typeof listSourceControlRepositorySummariesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSourceControlRepositorySummariesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourceControlRepositorySummariesAsUserQueryKey(options)
});

/**
 * Delete repository
 */
export const deleteRepositoryAsUserMutation = (options?: Partial<Options<DeleteRepositoryAsUserData>>): UseMutationOptions<DeleteRepositoryAsUserResponse, DefaultError, Options<DeleteRepositoryAsUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteRepositoryAsUserResponse, DefaultError, Options<DeleteRepositoryAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRepositoryAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listIndexingRunsAsUserQueryKey = (options?: Options<ListIndexingRunsAsUserData>) => createQueryKey('listIndexingRunsAsUser', options);

/**
 * List indexing runs
 */
export const listIndexingRunsAsUserOptions = (options?: Options<ListIndexingRunsAsUserData>) => queryOptions<ListIndexingRunsAsUserResponse, DefaultError, ListIndexingRunsAsUserResponse, ReturnType<typeof listIndexingRunsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listIndexingRunsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listIndexingRunsAsUserQueryKey(options)
});

/**
 * Create indexing run
 */
export const createIndexingRunAsUserMutation = (options?: Partial<Options<CreateIndexingRunAsUserData>>): UseMutationOptions<CreateIndexingRunAsUserResponse, DefaultError, Options<CreateIndexingRunAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateIndexingRunAsUserResponse, DefaultError, Options<CreateIndexingRunAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createIndexingRunAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFailedRepositoriesForIndexingRunAsUserQueryKey = (options: Options<GetFailedRepositoriesForIndexingRunAsUserData>) => createQueryKey('getFailedRepositoriesForIndexingRunAsUser', options);

/**
 * Get failed repositories for indexing run
 */
export const getFailedRepositoriesForIndexingRunAsUserOptions = (options: Options<GetFailedRepositoriesForIndexingRunAsUserData>) => queryOptions<GetFailedRepositoriesForIndexingRunAsUserResponse, DefaultError, GetFailedRepositoriesForIndexingRunAsUserResponse, ReturnType<typeof getFailedRepositoriesForIndexingRunAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFailedRepositoriesForIndexingRunAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFailedRepositoriesForIndexingRunAsUserQueryKey(options)
});

export const getIndexingRunInsightsAsUserQueryKey = (options: Options<GetIndexingRunInsightsAsUserData>) => createQueryKey('getIndexingRunInsightsAsUser', options);

/**
 * Get indexing run insights
 */
export const getIndexingRunInsightsAsUserOptions = (options: Options<GetIndexingRunInsightsAsUserData>) => queryOptions<GetIndexingRunInsightsAsUserResponse, DefaultError, GetIndexingRunInsightsAsUserResponse, ReturnType<typeof getIndexingRunInsightsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIndexingRunInsightsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIndexingRunInsightsAsUserQueryKey(options)
});

export const getRepositoryTopologyAsUserQueryKey = (options?: Options<GetRepositoryTopologyAsUserData>) => createQueryKey('getRepositoryTopologyAsUser', options);

/**
 * Get repository topology
 */
export const getRepositoryTopologyAsUserOptions = (options?: Options<GetRepositoryTopologyAsUserData>) => queryOptions<GetRepositoryTopologyAsUserResponse, DefaultError, GetRepositoryTopologyAsUserResponse, ReturnType<typeof getRepositoryTopologyAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRepositoryTopologyAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRepositoryTopologyAsUserQueryKey(options)
});

export const listRepositoryChatConversationsAsUserQueryKey = (options?: Options<ListRepositoryChatConversationsAsUserData>) => createQueryKey('listRepositoryChatConversationsAsUser', options);

/**
 * List repository chat conversations
 */
export const listRepositoryChatConversationsAsUserOptions = (options?: Options<ListRepositoryChatConversationsAsUserData>) => queryOptions<ListRepositoryChatConversationsAsUserResponse, DefaultError, ListRepositoryChatConversationsAsUserResponse, ReturnType<typeof listRepositoryChatConversationsAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRepositoryChatConversationsAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRepositoryChatConversationsAsUserQueryKey(options)
});

/**
 * Create a new repository chat conversation
 */
export const createANewRepositoryChatConversationAsUserMutation = (options?: Partial<Options<CreateANewRepositoryChatConversationAsUserData>>): UseMutationOptions<CreateANewRepositoryChatConversationAsUserResponse, DefaultError, Options<CreateANewRepositoryChatConversationAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateANewRepositoryChatConversationAsUserResponse, DefaultError, Options<CreateANewRepositoryChatConversationAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createANewRepositoryChatConversationAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getARepositoryChatConversationAsUserQueryKey = (options: Options<GetARepositoryChatConversationAsUserData>) => createQueryKey('getARepositoryChatConversationAsUser', options);

/**
 * Get a repository chat conversation
 */
export const getARepositoryChatConversationAsUserOptions = (options: Options<GetARepositoryChatConversationAsUserData>) => queryOptions<GetARepositoryChatConversationAsUserResponse, DefaultError, GetARepositoryChatConversationAsUserResponse, ReturnType<typeof getARepositoryChatConversationAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getARepositoryChatConversationAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getARepositoryChatConversationAsUserQueryKey(options)
});

/**
 * Create a repository chat message
 */
export const createARepositoryChatMessageAsUserMutation = (options?: Partial<Options<CreateARepositoryChatMessageAsUserData>>): UseMutationOptions<CreateARepositoryChatMessageAsUserResponse, DefaultError, Options<CreateARepositoryChatMessageAsUserData>> => {
    const mutationOptions: UseMutationOptions<CreateARepositoryChatMessageAsUserResponse, DefaultError, Options<CreateARepositoryChatMessageAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createARepositoryChatMessageAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPushBrokerOverviewAsUserQueryKey = (options?: Options<GetPushBrokerOverviewAsUserData>) => createQueryKey('getPushBrokerOverviewAsUser', options);

/**
 * Get push broker overview
 */
export const getPushBrokerOverviewAsUserOptions = (options?: Options<GetPushBrokerOverviewAsUserData>) => queryOptions<GetPushBrokerOverviewAsUserResponse, DefaultError, GetPushBrokerOverviewAsUserResponse, ReturnType<typeof getPushBrokerOverviewAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPushBrokerOverviewAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPushBrokerOverviewAsUserQueryKey(options)
});

export const listPushPoliciesForAChannelEnvironmentAsUserQueryKey = (options: Options<ListPushPoliciesForAChannelEnvironmentAsUserData>) => createQueryKey('listPushPoliciesForAChannelEnvironmentAsUser', options);

/**
 * List push policies for a channel environment
 */
export const listPushPoliciesForAChannelEnvironmentAsUserOptions = (options: Options<ListPushPoliciesForAChannelEnvironmentAsUserData>) => queryOptions<ListPushPoliciesForAChannelEnvironmentAsUserResponse, DefaultError, ListPushPoliciesForAChannelEnvironmentAsUserResponse, ReturnType<typeof listPushPoliciesForAChannelEnvironmentAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPushPoliciesForAChannelEnvironmentAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPushPoliciesForAChannelEnvironmentAsUserQueryKey(options)
});

/**
 * Enable or disable push for a repository attachment
 */
export const enableOrDisablePushForARepositoryAttachmentAsUserMutation = (options?: Partial<Options<EnableOrDisablePushForARepositoryAttachmentAsUserData>>): UseMutationOptions<EnableOrDisablePushForARepositoryAttachmentAsUserResponse, DefaultError, Options<EnableOrDisablePushForARepositoryAttachmentAsUserData>> => {
    const mutationOptions: UseMutationOptions<EnableOrDisablePushForARepositoryAttachmentAsUserResponse, DefaultError, Options<EnableOrDisablePushForARepositoryAttachmentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableOrDisablePushForARepositoryAttachmentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activate repository writes for a workspace if absent
 */
export const activateRepositoryWritesForAWorkspaceIfAbsentAsUserMutation = (options?: Partial<Options<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData>>): UseMutationOptions<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserResponse, DefaultError, Options<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData>> => {
    const mutationOptions: UseMutationOptions<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserResponse, DefaultError, Options<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateRepositoryWritesForAWorkspaceIfAbsentAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reviewRepositoryWritesBeforeAnOrgWideActivationAsUserQueryKey = (options: Options<ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserData>) => createQueryKey('reviewRepositoryWritesBeforeAnOrgWideActivationAsUser', options);

/**
 * Review repository writes before an org-wide activation
 */
export const reviewRepositoryWritesBeforeAnOrgWideActivationAsUserOptions = (options: Options<ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserData>) => queryOptions<ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserResponse, DefaultError, ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserResponse, ReturnType<typeof reviewRepositoryWritesBeforeAnOrgWideActivationAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await reviewRepositoryWritesBeforeAnOrgWideActivationAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: reviewRepositoryWritesBeforeAnOrgWideActivationAsUserQueryKey(options)
});

/**
 * Activate repository writes organization-wide after review
 */
export const activateRepositoryWritesOrganizationWideAfterReviewAsUserMutation = (options?: Partial<Options<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData>>): UseMutationOptions<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserResponse, DefaultError, Options<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData>> => {
    const mutationOptions: UseMutationOptions<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserResponse, DefaultError, Options<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateRepositoryWritesOrganizationWideAfterReviewAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Re-authorize revoked repository writes
 */
export const reAuthorizeRevokedRepositoryWritesAsUserMutation = (options?: Partial<Options<ReAuthorizeRevokedRepositoryWritesAsUserData>>): UseMutationOptions<ReAuthorizeRevokedRepositoryWritesAsUserResponse, DefaultError, Options<ReAuthorizeRevokedRepositoryWritesAsUserData>> => {
    const mutationOptions: UseMutationOptions<ReAuthorizeRevokedRepositoryWritesAsUserResponse, DefaultError, Options<ReAuthorizeRevokedRepositoryWritesAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reAuthorizeRevokedRepositoryWritesAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke repository writes organization-wide
 */
export const revokeRepositoryWritesOrganizationWideAsUserMutation = (options?: Partial<Options<RevokeRepositoryWritesOrganizationWideAsUserData>>): UseMutationOptions<RevokeRepositoryWritesOrganizationWideAsUserResponse, DefaultError, Options<RevokeRepositoryWritesOrganizationWideAsUserData>> => {
    const mutationOptions: UseMutationOptions<RevokeRepositoryWritesOrganizationWideAsUserResponse, DefaultError, Options<RevokeRepositoryWritesOrganizationWideAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeRepositoryWritesOrganizationWideAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSchemaTelemetryScopeSummaryAsUserQueryKey = (options?: Options<GetSchemaTelemetryScopeSummaryAsUserData>) => createQueryKey('getSchemaTelemetryScopeSummaryAsUser', options);

/**
 * Get schema telemetry scope summary
 */
export const getSchemaTelemetryScopeSummaryAsUserOptions = (options?: Options<GetSchemaTelemetryScopeSummaryAsUserData>) => queryOptions<GetSchemaTelemetryScopeSummaryAsUserResponse, DefaultError, GetSchemaTelemetryScopeSummaryAsUserResponse, ReturnType<typeof getSchemaTelemetryScopeSummaryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSchemaTelemetryScopeSummaryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSchemaTelemetryScopeSummaryAsUserQueryKey(options)
});

/**
 * Export schema telemetry
 */
export const exportSchemaTelemetryAsUserMutation = (options?: Partial<Options<ExportSchemaTelemetryAsUserData>>): UseMutationOptions<ExportSchemaTelemetryAsUserResponse, DefaultError, Options<ExportSchemaTelemetryAsUserData>> => {
    const mutationOptions: UseMutationOptions<ExportSchemaTelemetryAsUserResponse, DefaultError, Options<ExportSchemaTelemetryAsUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportSchemaTelemetryAsUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadTelemetryPromptAsUserQueryKey = (options: Options<DownloadTelemetryPromptAsUserData>) => createQueryKey('downloadTelemetryPromptAsUser', options);

/**
 * Download telemetry prompt
 */
export const downloadTelemetryPromptAsUserOptions = (options: Options<DownloadTelemetryPromptAsUserData>) => queryOptions<DownloadTelemetryPromptAsUserResponse, DefaultError, DownloadTelemetryPromptAsUserResponse, ReturnType<typeof downloadTelemetryPromptAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadTelemetryPromptAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadTelemetryPromptAsUserQueryKey(options)
});

export const downloadTelemetrySchemaAsUserQueryKey = (options: Options<DownloadTelemetrySchemaAsUserData>) => createQueryKey('downloadTelemetrySchemaAsUser', options);

/**
 * Download telemetry schema
 */
export const downloadTelemetrySchemaAsUserOptions = (options: Options<DownloadTelemetrySchemaAsUserData>) => queryOptions<DownloadTelemetrySchemaAsUserResponse, DefaultError, DownloadTelemetrySchemaAsUserResponse, ReturnType<typeof downloadTelemetrySchemaAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadTelemetrySchemaAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadTelemetrySchemaAsUserQueryKey(options)
});

export const getTelemetryRowByIdAsUserQueryKey = (options: Options<GetTelemetryRowByIdAsUserData>) => createQueryKey('getTelemetryRowByIdAsUser', options);

/**
 * Get telemetry row by ID
 */
export const getTelemetryRowByIdAsUserOptions = (options: Options<GetTelemetryRowByIdAsUserData>) => queryOptions<GetTelemetryRowByIdAsUserResponse, DefaultError, GetTelemetryRowByIdAsUserResponse, ReturnType<typeof getTelemetryRowByIdAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTelemetryRowByIdAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTelemetryRowByIdAsUserQueryKey(options)
});

export const listSchemaTelemetryAsUserQueryKey = (options?: Options<ListSchemaTelemetryAsUserData>) => createQueryKey('listSchemaTelemetryAsUser', options);

/**
 * List schema telemetry
 */
export const listSchemaTelemetryAsUserOptions = (options?: Options<ListSchemaTelemetryAsUserData>) => queryOptions<ListSchemaTelemetryAsUserResponse, DefaultError, ListSchemaTelemetryAsUserResponse, ReturnType<typeof listSchemaTelemetryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSchemaTelemetryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSchemaTelemetryAsUserQueryKey(options)
});

export const listSchemaTelemetryAsUserInfiniteQueryKey = (options?: Options<ListSchemaTelemetryAsUserData>): QueryKey<Options<ListSchemaTelemetryAsUserData>> => createQueryKey('listSchemaTelemetryAsUser', options, true);

/**
 * List schema telemetry
 */
export const listSchemaTelemetryAsUserInfiniteOptions = (options?: Options<ListSchemaTelemetryAsUserData>) => infiniteQueryOptions<ListSchemaTelemetryAsUserResponse, DefaultError, InfiniteData<ListSchemaTelemetryAsUserResponse>, QueryKey<Options<ListSchemaTelemetryAsUserData>>, string | Pick<QueryKey<Options<ListSchemaTelemetryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSchemaTelemetryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSchemaTelemetryAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSchemaTelemetryAsUserInfiniteQueryKey(options)
});

export const getQuotaForecastingSummaryAsUserQueryKey = (options?: Options<GetQuotaForecastingSummaryAsUserData>) => createQueryKey('getQuotaForecastingSummaryAsUser', options);

/**
 * Get quota forecasting summary
 */
export const getQuotaForecastingSummaryAsUserOptions = (options?: Options<GetQuotaForecastingSummaryAsUserData>) => queryOptions<GetQuotaForecastingSummaryAsUserResponse, DefaultError, GetQuotaForecastingSummaryAsUserResponse, ReturnType<typeof getQuotaForecastingSummaryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQuotaForecastingSummaryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQuotaForecastingSummaryAsUserQueryKey(options)
});

export const getQuotaForecastingSummaryAsUserInfiniteQueryKey = (options?: Options<GetQuotaForecastingSummaryAsUserData>): QueryKey<Options<GetQuotaForecastingSummaryAsUserData>> => createQueryKey('getQuotaForecastingSummaryAsUser', options, true);

/**
 * Get quota forecasting summary
 */
export const getQuotaForecastingSummaryAsUserInfiniteOptions = (options?: Options<GetQuotaForecastingSummaryAsUserData>) => infiniteQueryOptions<GetQuotaForecastingSummaryAsUserResponse, DefaultError, InfiniteData<GetQuotaForecastingSummaryAsUserResponse>, QueryKey<Options<GetQuotaForecastingSummaryAsUserData>>, string | Pick<QueryKey<Options<GetQuotaForecastingSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetQuotaForecastingSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getQuotaForecastingSummaryAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQuotaForecastingSummaryAsUserInfiniteQueryKey(options)
});

export const listQuotaForecastingEntriesAsUserQueryKey = (options?: Options<ListQuotaForecastingEntriesAsUserData>) => createQueryKey('listQuotaForecastingEntriesAsUser', options);

/**
 * List quota forecasting entries
 */
export const listQuotaForecastingEntriesAsUserOptions = (options?: Options<ListQuotaForecastingEntriesAsUserData>) => queryOptions<ListQuotaForecastingEntriesAsUserResponse, DefaultError, ListQuotaForecastingEntriesAsUserResponse, ReturnType<typeof listQuotaForecastingEntriesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listQuotaForecastingEntriesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listQuotaForecastingEntriesAsUserQueryKey(options)
});

export const listQuotaForecastingEntriesAsUserInfiniteQueryKey = (options?: Options<ListQuotaForecastingEntriesAsUserData>): QueryKey<Options<ListQuotaForecastingEntriesAsUserData>> => createQueryKey('listQuotaForecastingEntriesAsUser', options, true);

/**
 * List quota forecasting entries
 */
export const listQuotaForecastingEntriesAsUserInfiniteOptions = (options?: Options<ListQuotaForecastingEntriesAsUserData>) => infiniteQueryOptions<ListQuotaForecastingEntriesAsUserResponse, DefaultError, InfiniteData<ListQuotaForecastingEntriesAsUserResponse>, QueryKey<Options<ListQuotaForecastingEntriesAsUserData>>, string | Pick<QueryKey<Options<ListQuotaForecastingEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListQuotaForecastingEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listQuotaForecastingEntriesAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listQuotaForecastingEntriesAsUserInfiniteQueryKey(options)
});

export const getTimingSummaryAsUserQueryKey = (options?: Options<GetTimingSummaryAsUserData>) => createQueryKey('getTimingSummaryAsUser', options);

/**
 * Get timing summary
 */
export const getTimingSummaryAsUserOptions = (options?: Options<GetTimingSummaryAsUserData>) => queryOptions<GetTimingSummaryAsUserResponse, DefaultError, GetTimingSummaryAsUserResponse, ReturnType<typeof getTimingSummaryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTimingSummaryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTimingSummaryAsUserQueryKey(options)
});

export const getTimingSummaryAsUserInfiniteQueryKey = (options?: Options<GetTimingSummaryAsUserData>): QueryKey<Options<GetTimingSummaryAsUserData>> => createQueryKey('getTimingSummaryAsUser', options, true);

/**
 * Get timing summary
 */
export const getTimingSummaryAsUserInfiniteOptions = (options?: Options<GetTimingSummaryAsUserData>) => infiniteQueryOptions<GetTimingSummaryAsUserResponse, DefaultError, InfiniteData<GetTimingSummaryAsUserResponse>, QueryKey<Options<GetTimingSummaryAsUserData>>, string | Pick<QueryKey<Options<GetTimingSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetTimingSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getTimingSummaryAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTimingSummaryAsUserInfiniteQueryKey(options)
});

export const listTimingEntriesAsUserQueryKey = (options?: Options<ListTimingEntriesAsUserData>) => createQueryKey('listTimingEntriesAsUser', options);

/**
 * List timing entries
 */
export const listTimingEntriesAsUserOptions = (options?: Options<ListTimingEntriesAsUserData>) => queryOptions<ListTimingEntriesAsUserResponse, DefaultError, ListTimingEntriesAsUserResponse, ReturnType<typeof listTimingEntriesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTimingEntriesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTimingEntriesAsUserQueryKey(options)
});

export const listTimingEntriesAsUserInfiniteQueryKey = (options?: Options<ListTimingEntriesAsUserData>): QueryKey<Options<ListTimingEntriesAsUserData>> => createQueryKey('listTimingEntriesAsUser', options, true);

/**
 * List timing entries
 */
export const listTimingEntriesAsUserInfiniteOptions = (options?: Options<ListTimingEntriesAsUserData>) => infiniteQueryOptions<ListTimingEntriesAsUserResponse, DefaultError, InfiniteData<ListTimingEntriesAsUserResponse>, QueryKey<Options<ListTimingEntriesAsUserData>>, string | Pick<QueryKey<Options<ListTimingEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTimingEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTimingEntriesAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTimingEntriesAsUserInfiniteQueryKey(options)
});

export const getUsageSummaryAsUserQueryKey = (options?: Options<GetUsageSummaryAsUserData>) => createQueryKey('getUsageSummaryAsUser', options);

/**
 * Get usage summary
 */
export const getUsageSummaryAsUserOptions = (options?: Options<GetUsageSummaryAsUserData>) => queryOptions<GetUsageSummaryAsUserResponse, DefaultError, GetUsageSummaryAsUserResponse, ReturnType<typeof getUsageSummaryAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsageSummaryAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsageSummaryAsUserQueryKey(options)
});

export const getUsageSummaryAsUserInfiniteQueryKey = (options?: Options<GetUsageSummaryAsUserData>): QueryKey<Options<GetUsageSummaryAsUserData>> => createQueryKey('getUsageSummaryAsUser', options, true);

/**
 * Get usage summary
 */
export const getUsageSummaryAsUserInfiniteOptions = (options?: Options<GetUsageSummaryAsUserData>) => infiniteQueryOptions<GetUsageSummaryAsUserResponse, DefaultError, InfiniteData<GetUsageSummaryAsUserResponse>, QueryKey<Options<GetUsageSummaryAsUserData>>, string | Pick<QueryKey<Options<GetUsageSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetUsageSummaryAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getUsageSummaryAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsageSummaryAsUserInfiniteQueryKey(options)
});

export const listUsageEntriesAsUserQueryKey = (options?: Options<ListUsageEntriesAsUserData>) => createQueryKey('listUsageEntriesAsUser', options);

/**
 * List usage entries
 */
export const listUsageEntriesAsUserOptions = (options?: Options<ListUsageEntriesAsUserData>) => queryOptions<ListUsageEntriesAsUserResponse, DefaultError, ListUsageEntriesAsUserResponse, ReturnType<typeof listUsageEntriesAsUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUsageEntriesAsUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsageEntriesAsUserQueryKey(options)
});

export const listUsageEntriesAsUserInfiniteQueryKey = (options?: Options<ListUsageEntriesAsUserData>): QueryKey<Options<ListUsageEntriesAsUserData>> => createQueryKey('listUsageEntriesAsUser', options, true);

/**
 * List usage entries
 */
export const listUsageEntriesAsUserInfiniteOptions = (options?: Options<ListUsageEntriesAsUserData>) => infiniteQueryOptions<ListUsageEntriesAsUserResponse, DefaultError, InfiniteData<ListUsageEntriesAsUserResponse>, QueryKey<Options<ListUsageEntriesAsUserData>>, string | Pick<QueryKey<Options<ListUsageEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListUsageEntriesAsUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listUsageEntriesAsUser({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsageEntriesAsUserInfiniteQueryKey(options)
});

export const listDefaultAgentModeBudgetsAsAdminQueryKey = (options?: Options<ListDefaultAgentModeBudgetsAsAdminData>) => createQueryKey('listDefaultAgentModeBudgetsAsAdmin', options);

/**
 * List default agent mode budgets
 */
export const listDefaultAgentModeBudgetsAsAdminOptions = (options?: Options<ListDefaultAgentModeBudgetsAsAdminData>) => queryOptions<ListDefaultAgentModeBudgetsAsAdminResponse, DefaultError, ListDefaultAgentModeBudgetsAsAdminResponse, ReturnType<typeof listDefaultAgentModeBudgetsAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDefaultAgentModeBudgetsAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDefaultAgentModeBudgetsAsAdminQueryKey(options)
});

/**
 * Reseed agent mode budgets for organizations
 */
export const reseedAgentModeBudgetsForOrganizationsAsAdminMutation = (options?: Partial<Options<ReseedAgentModeBudgetsForOrganizationsAsAdminData>>): UseMutationOptions<ReseedAgentModeBudgetsForOrganizationsAsAdminResponse, DefaultError, Options<ReseedAgentModeBudgetsForOrganizationsAsAdminData>> => {
    const mutationOptions: UseMutationOptions<ReseedAgentModeBudgetsForOrganizationsAsAdminResponse, DefaultError, Options<ReseedAgentModeBudgetsForOrganizationsAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reseedAgentModeBudgetsForOrganizationsAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrganizationFeatureFlagOverridesAsAdminQueryKey = (options?: Options<ListOrganizationFeatureFlagOverridesAsAdminData>) => createQueryKey('listOrganizationFeatureFlagOverridesAsAdmin', options);

/**
 * List organization feature flag overrides
 */
export const listOrganizationFeatureFlagOverridesAsAdminOptions = (options?: Options<ListOrganizationFeatureFlagOverridesAsAdminData>) => queryOptions<ListOrganizationFeatureFlagOverridesAsAdminResponse, DefaultError, ListOrganizationFeatureFlagOverridesAsAdminResponse, ReturnType<typeof listOrganizationFeatureFlagOverridesAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationFeatureFlagOverridesAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationFeatureFlagOverridesAsAdminQueryKey(options)
});

/**
 * Set organization feature flag override
 */
export const setOrganizationFeatureFlagOverrideAsAdminMutation = (options?: Partial<Options<SetOrganizationFeatureFlagOverrideAsAdminData>>): UseMutationOptions<SetOrganizationFeatureFlagOverrideAsAdminResponse, DefaultError, Options<SetOrganizationFeatureFlagOverrideAsAdminData>> => {
    const mutationOptions: UseMutationOptions<SetOrganizationFeatureFlagOverrideAsAdminResponse, DefaultError, Options<SetOrganizationFeatureFlagOverrideAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOrganizationFeatureFlagOverrideAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEnrolledSandboxHostBindingsAsAdminQueryKey = (options?: Options<ListEnrolledSandboxHostBindingsAsAdminData>) => createQueryKey('listEnrolledSandboxHostBindingsAsAdmin', options);

/**
 * List enrolled sandbox host bindings
 */
export const listEnrolledSandboxHostBindingsAsAdminOptions = (options?: Options<ListEnrolledSandboxHostBindingsAsAdminData>) => queryOptions<ListEnrolledSandboxHostBindingsAsAdminResponse, DefaultError, ListEnrolledSandboxHostBindingsAsAdminResponse, ReturnType<typeof listEnrolledSandboxHostBindingsAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEnrolledSandboxHostBindingsAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEnrolledSandboxHostBindingsAsAdminQueryKey(options)
});

/**
 * Enroll a sandbox host binding
 */
export const enrollASandboxHostBindingAsAdminMutation = (options?: Partial<Options<EnrollASandboxHostBindingAsAdminData>>): UseMutationOptions<EnrollASandboxHostBindingAsAdminResponse, DefaultError, Options<EnrollASandboxHostBindingAsAdminData>> => {
    const mutationOptions: UseMutationOptions<EnrollASandboxHostBindingAsAdminResponse, DefaultError, Options<EnrollASandboxHostBindingAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrollASandboxHostBindingAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const inspectASandboxHostBindingAndItsFenceTargetsAsAdminQueryKey = (options: Options<InspectASandboxHostBindingAndItsFenceTargetsAsAdminData>) => createQueryKey('inspectASandboxHostBindingAndItsFenceTargetsAsAdmin', options);

/**
 * Inspect a sandbox host binding and its fence targets
 */
export const inspectASandboxHostBindingAndItsFenceTargetsAsAdminOptions = (options: Options<InspectASandboxHostBindingAndItsFenceTargetsAsAdminData>) => queryOptions<InspectASandboxHostBindingAndItsFenceTargetsAsAdminResponse, DefaultError, InspectASandboxHostBindingAndItsFenceTargetsAsAdminResponse, ReturnType<typeof inspectASandboxHostBindingAndItsFenceTargetsAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await inspectASandboxHostBindingAndItsFenceTargetsAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: inspectASandboxHostBindingAndItsFenceTargetsAsAdminQueryKey(options)
});

/**
 * Attest that an enrolled sandbox host is permanently gone
 */
export const attestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminMutation = (options?: Partial<Options<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData>>): UseMutationOptions<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminResponse, DefaultError, Options<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData>> => {
    const mutationOptions: UseMutationOptions<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminResponse, DefaultError, Options<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listKeystoreEntriesAsAdminQueryKey = (options?: Options<ListKeystoreEntriesAsAdminData>) => createQueryKey('listKeystoreEntriesAsAdmin', options);

/**
 * List keystore entries
 */
export const listKeystoreEntriesAsAdminOptions = (options?: Options<ListKeystoreEntriesAsAdminData>) => queryOptions<ListKeystoreEntriesAsAdminResponse, DefaultError, ListKeystoreEntriesAsAdminResponse, ReturnType<typeof listKeystoreEntriesAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listKeystoreEntriesAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listKeystoreEntriesAsAdminQueryKey(options)
});

/**
 * Create keystore entry
 */
export const createKeystoreEntryAsAdminMutation = (options?: Partial<Options<CreateKeystoreEntryAsAdminData>>): UseMutationOptions<CreateKeystoreEntryAsAdminResponse, DefaultError, Options<CreateKeystoreEntryAsAdminData>> => {
    const mutationOptions: UseMutationOptions<CreateKeystoreEntryAsAdminResponse, DefaultError, Options<CreateKeystoreEntryAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createKeystoreEntryAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete keystore entry
 */
export const deleteKeystoreEntryAsAdminMutation = (options?: Partial<Options<DeleteKeystoreEntryAsAdminData>>): UseMutationOptions<DeleteKeystoreEntryAsAdminResponse, DefaultError, Options<DeleteKeystoreEntryAsAdminData>> => {
    const mutationOptions: UseMutationOptions<DeleteKeystoreEntryAsAdminResponse, DefaultError, Options<DeleteKeystoreEntryAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteKeystoreEntryAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign keystore entry
 */
export const assignKeystoreEntryAsAdminMutation = (options?: Partial<Options<AssignKeystoreEntryAsAdminData>>): UseMutationOptions<AssignKeystoreEntryAsAdminResponse, DefaultError, Options<AssignKeystoreEntryAsAdminData>> => {
    const mutationOptions: UseMutationOptions<AssignKeystoreEntryAsAdminResponse, DefaultError, Options<AssignKeystoreEntryAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignKeystoreEntryAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign keystore entry
 */
export const unassignKeystoreEntryAsAdminMutation = (options?: Partial<Options<UnassignKeystoreEntryAsAdminData>>): UseMutationOptions<UnassignKeystoreEntryAsAdminResponse, DefaultError, Options<UnassignKeystoreEntryAsAdminData>> => {
    const mutationOptions: UseMutationOptions<UnassignKeystoreEntryAsAdminResponse, DefaultError, Options<UnassignKeystoreEntryAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignKeystoreEntryAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getKeystoreSpendingAsAdminQueryKey = (options?: Options<GetKeystoreSpendingAsAdminData>) => createQueryKey('getKeystoreSpendingAsAdmin', options);

/**
 * Get keystore spending
 */
export const getKeystoreSpendingAsAdminOptions = (options?: Options<GetKeystoreSpendingAsAdminData>) => queryOptions<GetKeystoreSpendingAsAdminResponse, DefaultError, GetKeystoreSpendingAsAdminResponse, ReturnType<typeof getKeystoreSpendingAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getKeystoreSpendingAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKeystoreSpendingAsAdminQueryKey(options)
});

export const getKeystoreSpendingAsAdminInfiniteQueryKey = (options?: Options<GetKeystoreSpendingAsAdminData>): QueryKey<Options<GetKeystoreSpendingAsAdminData>> => createQueryKey('getKeystoreSpendingAsAdmin', options, true);

/**
 * Get keystore spending
 */
export const getKeystoreSpendingAsAdminInfiniteOptions = (options?: Options<GetKeystoreSpendingAsAdminData>) => infiniteQueryOptions<GetKeystoreSpendingAsAdminResponse, DefaultError, InfiniteData<GetKeystoreSpendingAsAdminResponse>, QueryKey<Options<GetKeystoreSpendingAsAdminData>>, string | Pick<QueryKey<Options<GetKeystoreSpendingAsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetKeystoreSpendingAsAdminData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getKeystoreSpendingAsAdmin({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKeystoreSpendingAsAdminInfiniteQueryKey(options)
});

export const listOrganizationsForAdminAsAdminQueryKey = (options?: Options<ListOrganizationsForAdminAsAdminData>) => createQueryKey('listOrganizationsForAdminAsAdmin', options);

/**
 * List organizations for admin
 */
export const listOrganizationsForAdminAsAdminOptions = (options?: Options<ListOrganizationsForAdminAsAdminData>) => queryOptions<ListOrganizationsForAdminAsAdminResponse, DefaultError, ListOrganizationsForAdminAsAdminResponse, ReturnType<typeof listOrganizationsForAdminAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrganizationsForAdminAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrganizationsForAdminAsAdminQueryKey(options)
});

/**
 * Grant organization credits
 */
export const grantOrganizationCreditsAsAdminMutation = (options?: Partial<Options<GrantOrganizationCreditsAsAdminData>>): UseMutationOptions<GrantOrganizationCreditsAsAdminResponse, DefaultError, Options<GrantOrganizationCreditsAsAdminData>> => {
    const mutationOptions: UseMutationOptions<GrantOrganizationCreditsAsAdminResponse, DefaultError, Options<GrantOrganizationCreditsAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantOrganizationCreditsAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminOverviewAsAdminQueryKey = (options?: Options<GetAdminOverviewAsAdminData>) => createQueryKey('getAdminOverviewAsAdmin', options);

/**
 * Get admin overview
 */
export const getAdminOverviewAsAdminOptions = (options?: Options<GetAdminOverviewAsAdminData>) => queryOptions<GetAdminOverviewAsAdminResponse, DefaultError, GetAdminOverviewAsAdminResponse, ReturnType<typeof getAdminOverviewAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminOverviewAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminOverviewAsAdminQueryKey(options)
});

export const listPlatformUsersAsAdminQueryKey = (options?: Options<ListPlatformUsersAsAdminData>) => createQueryKey('listPlatformUsersAsAdmin', options);

/**
 * List platform users
 */
export const listPlatformUsersAsAdminOptions = (options?: Options<ListPlatformUsersAsAdminData>) => queryOptions<ListPlatformUsersAsAdminResponse, DefaultError, ListPlatformUsersAsAdminResponse, ReturnType<typeof listPlatformUsersAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformUsersAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformUsersAsAdminQueryKey(options)
});

/**
 * Invalidate all sessions for a user
 */
export const invalidateAllSessionsForAuserAsAdminMutation = (options?: Partial<Options<InvalidateAllSessionsForAuserAsAdminData>>): UseMutationOptions<InvalidateAllSessionsForAuserAsAdminResponse, DefaultError, Options<InvalidateAllSessionsForAuserAsAdminData>> => {
    const mutationOptions: UseMutationOptions<InvalidateAllSessionsForAuserAsAdminResponse, DefaultError, Options<InvalidateAllSessionsForAuserAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invalidateAllSessionsForAuserAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listArchivedTeamsChannelsAsAdminQueryKey = (options: Options<ListArchivedTeamsChannelsAsAdminData>) => createQueryKey('listArchivedTeamsChannelsAsAdmin', options);

/**
 * List archived Teams channels
 */
export const listArchivedTeamsChannelsAsAdminOptions = (options: Options<ListArchivedTeamsChannelsAsAdminData>) => queryOptions<ListArchivedTeamsChannelsAsAdminResponse, DefaultError, ListArchivedTeamsChannelsAsAdminResponse, ReturnType<typeof listArchivedTeamsChannelsAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArchivedTeamsChannelsAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArchivedTeamsChannelsAsAdminQueryKey(options)
});

export const listTeamsOutboxMessagesAsAdminQueryKey = (options: Options<ListTeamsOutboxMessagesAsAdminData>) => createQueryKey('listTeamsOutboxMessagesAsAdmin', options);

/**
 * List Teams outbox messages
 */
export const listTeamsOutboxMessagesAsAdminOptions = (options: Options<ListTeamsOutboxMessagesAsAdminData>) => queryOptions<ListTeamsOutboxMessagesAsAdminResponse, DefaultError, ListTeamsOutboxMessagesAsAdminResponse, ReturnType<typeof listTeamsOutboxMessagesAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTeamsOutboxMessagesAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTeamsOutboxMessagesAsAdminQueryKey(options)
});

/**
 * Retry Teams outbox message
 */
export const retryTeamsOutboxMessageAsAdminMutation = (options?: Partial<Options<RetryTeamsOutboxMessageAsAdminData>>): UseMutationOptions<RetryTeamsOutboxMessageAsAdminResponse, DefaultError, Options<RetryTeamsOutboxMessageAsAdminData>> => {
    const mutationOptions: UseMutationOptions<RetryTeamsOutboxMessageAsAdminResponse, DefaultError, Options<RetryTeamsOutboxMessageAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryTeamsOutboxMessageAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Skip Teams outbox message
 */
export const skipTeamsOutboxMessageAsAdminMutation = (options?: Partial<Options<SkipTeamsOutboxMessageAsAdminData>>): UseMutationOptions<SkipTeamsOutboxMessageAsAdminResponse, DefaultError, Options<SkipTeamsOutboxMessageAsAdminData>> => {
    const mutationOptions: UseMutationOptions<SkipTeamsOutboxMessageAsAdminResponse, DefaultError, Options<SkipTeamsOutboxMessageAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await skipTeamsOutboxMessageAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel Teams outbox message
 */
export const cancelTeamsOutboxMessageAsAdminMutation = (options?: Partial<Options<CancelTeamsOutboxMessageAsAdminData>>): UseMutationOptions<CancelTeamsOutboxMessageAsAdminResponse, DefaultError, Options<CancelTeamsOutboxMessageAsAdminData>> => {
    const mutationOptions: UseMutationOptions<CancelTeamsOutboxMessageAsAdminResponse, DefaultError, Options<CancelTeamsOutboxMessageAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelTeamsOutboxMessageAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTeamsAdminSetupAsAdminQueryKey = (options: Options<GetTeamsAdminSetupAsAdminData>) => createQueryKey('getTeamsAdminSetupAsAdmin', options);

/**
 * Get Teams admin setup
 */
export const getTeamsAdminSetupAsAdminOptions = (options: Options<GetTeamsAdminSetupAsAdminData>) => queryOptions<GetTeamsAdminSetupAsAdminResponse, DefaultError, GetTeamsAdminSetupAsAdminResponse, ReturnType<typeof getTeamsAdminSetupAsAdminQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTeamsAdminSetupAsAdmin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTeamsAdminSetupAsAdminQueryKey(options)
});

/**
 * Save Teams admin setup
 */
export const saveTeamsAdminSetupAsAdminMutation = (options?: Partial<Options<SaveTeamsAdminSetupAsAdminData>>): UseMutationOptions<SaveTeamsAdminSetupAsAdminResponse, DefaultError, Options<SaveTeamsAdminSetupAsAdminData>> => {
    const mutationOptions: UseMutationOptions<SaveTeamsAdminSetupAsAdminResponse, DefaultError, Options<SaveTeamsAdminSetupAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveTeamsAdminSetupAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate Teams bot credentials
 */
export const validateTeamsBotCredentialsAsAdminMutation = (options?: Partial<Options<ValidateTeamsBotCredentialsAsAdminData>>): UseMutationOptions<ValidateTeamsBotCredentialsAsAdminResponse, DefaultError, Options<ValidateTeamsBotCredentialsAsAdminData>> => {
    const mutationOptions: UseMutationOptions<ValidateTeamsBotCredentialsAsAdminResponse, DefaultError, Options<ValidateTeamsBotCredentialsAsAdminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateTeamsBotCredentialsAsAdmin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle Stripe webhook
 */
export const handleStripeWebhookAsWebhookMutation = (options?: Partial<Options<HandleStripeWebhookAsWebhookData>>): UseMutationOptions<HandleStripeWebhookAsWebhookResponse, DefaultError, Options<HandleStripeWebhookAsWebhookData>> => {
    const mutationOptions: UseMutationOptions<HandleStripeWebhookAsWebhookResponse, DefaultError, Options<HandleStripeWebhookAsWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleStripeWebhookAsWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
